import "./App.css";
import {
  ArrowRight,
  Award,
  Check,
  ChevronLeft,
  ChevronRight,
  ExternalLink,
  FileText,
  Mail,
  MapPin,
  Menu,
  Phone,
  ShieldCheck,
  X,
} from "lucide-react";
import { useEffect, useState } from "react";
import AboutCatalogs from "./components/about/AboutCatalogs";
import { isEmailConfigured, sendContactMessage } from "./services/emailService";

const navigation = [
  {
    title: "Kurumsal",
    items: [
      ["Hakkımızda", "/kurumsal/hakkimizda"],
      ["Ar-Ge ve Teknoloji", "/kurumsal/ar-ge-ve-teknoloji"],
      ["Belgelerimiz", "/kurumsal/belgelerimiz"],
      ["Politikalarımız", "/kurumsal/politikalarimiz"],
      ["İş Ortaklarımız ve Referanslar", "/kurumsal/referanslar"],
    ],
  },
  {
    title: "Çözümlerimiz",
    items: [
      ["Atık Toplama ve Saha Operasyonları", "/cozumler/atik-toplama"],
      ["Araç, Rota ve Lojistik Yönetimi", "/cozumler/lojistik-yonetimi"],
      ["Ekipman ve Envanter Yönetimi", "/cozumler/envanter-yonetimi"],
      ["Depozito Yönetimi", "/cozumler/depozito-yonetimi"],
      ["Raporlama ve Sürdürülebilirlik", "/cozumler/raporlama"],
      ["Entegrasyonlar ve Dijital Evrak", "/cozumler/entegrasyonlar"],
      ["Evsel Atık (Çöp) Yönetimi", "/cozumler/evsel-atik"],
    ],
  },
  {
    title: "Kaynaklar",
    items: [
      ["Blog", "/blog"],
      ["Atık Yönetimi Rehberi", "/kaynaklar/rehber"],
      ["Sıkça Sorulan Sorular", "/kaynaklar/sss"],
    ],
  },
  { title: "İletişim", href: "/#iletisim-form" },
];

const news = [
  {
    image: "/news/teknokatalog.png",
    date: "20 Kasım 2025",
    tag: "Teknokatalog",
    title: "ATIKSOFT Artık Teknokatalog'ta!",
    description:
      "ATIKSOFT, DMO Tekno Kataloğu'nda yer alarak kamu kurumları ve belediyeler için daha hızlı, şeffaf ve güvenli bir temin kanalı sunuyor.",
  },
  {
    image: "/news/gcip-finalist.png",
    date: "11 Aralık 2024",
    tag: "GCIP Finalist",
    title: "ATIKSOFT, GCIP Türkiye 2024 Programının Finalistleri Arasında",
    description:
      "TÜBİTAK ve UNIDO iş birliğiyle yürütülen GCIP Türkiye 2024 Hızlandırıcı Programı'nın finalist girişimleri arasında yer aldık.",
  },
  {
    image: "/blog/dbys-entegrasyonu.png",
    date: "26 Ağustos 2026",
    tag: "DBYS Entegrasyonu",
    title: "ATIKSOFT Depozito - DBYS Entegrasyonu",
    description:
      "ATIKSOFT Depozito, Depozito Bilgi Yönetim Sistemi (DBYS) ile entegre çalışarak depozito toplama operasyonlarının dijital ve izlenebilir şekilde yönetilmesini sağlar.",
  },
];

const blogPosts = [
  {
    image: "/blog/dbys-entegrasyonu.png",
    date: "26 Ağustos 2026",
    tag: "DBYS Entegrasyonu",
    title: "ATIKSOFT Depozito - DBYS Entegrasyonu",
    description:
      "ATIKSOFT Depozito, Depozito Bilgi Yönetim Sistemi (DBYS) ile entegre çalışarak depozito toplama operasyonlarının dijital ve izlenebilir şekilde yönetilmesini sağlar. Toplama, taşıma ve saha verileri tek platform üzerinden takip edilerek ilgili veriler DBYS altyapısıyla uyumlu şekilde yönetilir.",
  },
  {
    image: "/blog/teknogirisim-rozeti.png",
    date: "29 Temmuz 2026",
    tag: "Teknogirişim Rozeti",
    title: "Teknogirişim Rozeti Aldık!",
    description:
      "Teknoloji ve Yenilik Odaklı Girişimlerin Belirlenmesi ve Belgelendirilmesine Dair Yönetmelik kapsamında Teknogirişim Rozeti almaya hak kazandık. 29 Temmuz 2026 tarihinde onaylanan belge, üç yıl süreyle geçerli olacak. Teknoloji ve yenilik odaklı çalışmalarımızı sürdürülebilir çözümlerle buluşturmaya ve geliştirdiğimiz dijital altyapıları ileriye taşımaya devam ediyoruz.",
  },
  ...news,
  {
    image: "/arge.jpeg",
    date: "15 Kasım 2024",
    tag: "TÜBİTAK 1507",
    title: "ATIKSOFT TÜBİTAK 1507 Ar-Ge Projesini Başarıyla Tamamladı",
    description:
      "Dijital atık yönetimi altyapımızı güçlendirmek amacıyla yürüttüğümüz TÜBİTAK 1507 Ar-Ge Projesi başarıyla tamamlandı. Proje kapsamında atık akışının uçtan uca izlenebilirliğini sağlayan yeni nesil modüller geliştirildi.",
  },
  {
    image: "/blog/iyi-niyet-beyani.png",
    date: "26 Ağustos 2026",
    tag: "Sürdürülebilirlik",
    title: "ATIKSOFT, Sıfır Atık İyi Niyet Beyanı'nı İmzaladı",
    description:
      "ATIKSOFT olarak sürdürülebilir kaynak yönetimi ve sıfır atık yaklaşımını destekliyoruz. Bu kapsamda Sıfır Atık Vakfı tarafından yürütülen iyi niyet beyanına katılarak, daha sürdürülebilir bir gelecek için ortak sorumluluk anlayışımızı bir kez daha ortaya koyduk.",
  },
];

const placeholderPages = {
  "/kurumsal/ar-ge-ve-teknoloji": ["Kurumsal", "Ar-Ge ve Teknoloji"],
  "/cozumler/atık-toplama": [
    "Çözümlerimiz",
    "Atık Toplama ve Saha Operasyonları",
  ],
  "/cozumler/lojistik-yonetimi": [
    "Çözümlerimiz",
    "Araç, Rota ve Lojistik Yönetimi",
  ],
  "/cozumler/envanter-yonetimi": [
    "Çözümlerimiz",
    "Ekipman ve Envanter Yönetimi",
  ],
  "/cozumler/depozito-yonetimi": ["Çözümlerimiz", "Depozito Yönetimi"],
  "/cozumler/raporlama": ["Çözümlerimiz", "Raporlama ve Sürdürülebilirlik"],
  "/cozumler/entegrasyonlar": [
    "Çözümlerimiz",
    "Entegrasyonlar ve Dijital Evrak",
  ],
  "/cozumler/evsel-atik": ["Çözümlerimiz", "Evsel Atık (Çöp) Yönetimi"],
  "/kaynaklar/rehber": ["Kaynaklar", "Atık Yönetimi Rehberi"],
};

const referenceLogos = [
  {
    name: "Bucak Belediyesi",
    category: "Belediyeler",
    image: "/references/bucak-belediyesi.png",
  },
  {
    name: "Konak Belediyesi",
    category: "Belediyeler",
    image: "/references/konak-belediyesi.jpg",
  },
  {
    name: "Özen Cam",
    category: "Özel Kuruluşlar",
    image: "/references/ozen-cam.png",
  },
  {
    name: "Erkan Özen Geri Dönüşüm",
    category: "Özel Kuruluşlar",
    image: "/references/erkan-ozen.jpg",
  },
  {
    name: "ÇEVKO",
    category: "Özel Kuruluşlar",
    image: "/references/cevko.png",
  },
  {
    name: "ATKASAN",
    category: "Özel Kuruluşlar",
    image: "/references/atkasan.png",
  },
  {
    name: "Akademi Çevre",
    category: "Özel Kuruluşlar",
    image: "/akademi_cevre.jpeg",
  },
  {
    name: "Çevreci Atık Toplayıcıları Koop.",
    category: "Kooperatifler",
    image: "/references/cevreci-atik-toplayicilari.png",
  },
];

const solutionCards = [
  {
    title: "Saha Operasyonları",
    text: "Toplama süreçlerinizi planlayın, yönetin ve anlık olarak takip edin.",
    href: "/cozumler/atik-toplama",
  },
  {
    title: "Rota & Lojistik",
    text: "Akıllı rotalarla zaman ve yakıt tasarrufu sağlayın.",
    href: "/cozumler/lojistik-yonetimi",
  },
  {
    title: "Raporlama",
    text: "Verilerinizi anlamlı içgörülere dönüştürün.",
    href: "/cozumler/raporlama",
  },
  {
    title: "Evsel Atık Yönetimi",
    text: "Evsel atık toplama operasyonlarını uçtan uca yönetin.",
    href: "/cozumler/evsel-atik",
  },
  {
    title: "Entegrasyonlar",
    text: "Dijital sistemlerinizi tek bir veri akışında birleştirin.",
    href: "/cozumler/entegrasyonlar",
  },
  {
    title: "Envanter Yönetimi",
    text: "Ekipman ve varlıklarınızı kolayca izleyin.",
    href: "/cozumler/envanter-yonetimi",
  },
  {
    title: "Depozito Yönetimi",
    text: "Depozito operasyonlarını sahadan merkeze yönetin.",
    href: "/cozumler/depozito-yonetimi",
  },
];

const policies = [
  {
    title: "Etik İş İlkeleri ve Yolsuzlukla Mücadele Politikası",
    file: "/policies/etik-is-ilkeleri.pdf",
    category: "Etik ve Uyum",
  },
  {
    title: "Veri ve Bilgi Güvenliği Politikası",
    file: "/policies/veri-bilgi-guvenligi.pdf",
    category: "Güvenlik",
  },
  {
    title: "Eşitlik, Çeşitlilik ve Kapsayıcılık Politikası",
    file: "/policies/esitlik-cesitlilik-kapsayicilik.pdf",
    category: "İnsan ve Kültür",
  },
  {
    title: "Çocuk İşçiliği ve Zorla Çalıştırma ile Mücadele Politikası",
    file: "/policies/cocuk-isciligi.pdf",
    category: "İnsan ve Kültür",
  },
  {
    title: "İnsan Kaynakları Politikası",
    file: "/policies/insan-kaynaklari.pdf",
    category: "İnsan ve Kültür",
  },
  {
    title: "İş Sağlığı ve Güvenliği Politikası",
    file: "/policies/is-sagligi-guvenligi.pdf",
    category: "İş Süreçleri",
  },
  {
    title: "Çevre ve Sürdürülebilirlik Politikası",
    file: "/policies/cevre-surdurulebilirlik.pdf",
    category: "Sürdürülebilirlik",
  },
  {
    title: "Kalite ve Müşteri Memnuniyeti Politikası",
    file: "/policies/kalite-musteri-memnuniyeti.pdf",
    category: "İş Süreçleri",
  },
];

const documents = [
  {
    title: "ISO 27001:2022 Bilgi Güvenliği Yönetim Sistemi Sertifikası",
    image: "/certificate2.png",
  },
  {
    title: "ISO 9001:2015 Kalite Yönetim Sistemi Sertifikası",
    image: "/certificate1.png",
  },
  {
    title: "ATIKSOFT Marka Tescil Belgesi",
    image: "/atiksoftMarkaTescilBelgesi.png",
  },
  { title: "Tür Belgesi", image: "/turBelgesi.png" },
  { title: "Yerli Malı Belgesi", image: "/yerliMaliBelgesi.png" },
  { title: "Sanayi Sicil Belgesi", image: "/sanayisicilBelgesi.png" },
];

const faqItems = [
  [
    "ATIKSOFT kimler için uygun bir çözüm?",
    "ATIKSOFT; *lisanslı atık toplama ve geri kazanım firmaları, belediyeler, kamu kurumları, sanayi tesisleri ve farklı noktalarda atık operasyonu yöneten kuruluşlar* için geliştirilmiş esnek bir atık yönetim platformudur.\n\nSistem, kurumun operasyon yapısına ve ihtiyaçlarına göre yapılandırılabilir.",
  ],
  [
    "Kamu kurumları ATIKSOFT'u Devlet Malzeme Ofisi üzerinden satın alabilir mi?",
    "*Evet. ATIKSOFT, Devlet Malzeme Ofisi Tekno Katalog'da yer almaktadır.*\n\nBu sayede kamu kurum ve kuruluşları, yürürlükteki DMO satın alma usul ve limitleri doğrultusunda ATIKSOFT'a *DMO üzerinden erişebilir ve satın alma süreçlerini yürütebilir.*",
  ],
  [
    "ATIKSOFT'u kullanmaya başlamak için temel olarak nelere ihtiyaç var?",
    "ATIKSOFT'un kullanımına başlamak için temel olarak *internet bağlantısı bulunan bir bilgisayar ve/veya akıllı telefon* yeterlidir.\n\nOperasyonun ihtiyacına göre kantar, araç tartım sistemleri, sensörler veya farklı saha ekipmanları sisteme entegre edilebilir; ancak bunların tamamı sistemi kullanmaya başlamak için zorunlu değildir.",
  ],
  [
    "ATIKSOFT'u kullanmak için sensör satın almak zorunlu mu?",
    "*Hayır.*\n\nATIKSOFT sensör bağımlı bir sistem değildir. İhtiyaç halinde doluluk sensörleri ve farklı IoT ekipmanlarıyla entegre çalışabilir; ancak sensör kullanılmadan da saha verilerinin toplanması, operasyonların izlenmesi, iş emirlerinin yönetilmesi ve raporlanması mümkündür.\n\nSahadaki deneyimimizi ve atık yönetimi konusundaki bilgi birikimimizi kullanarak, *gereksiz donanım yatırımı oluşturmadan ihtiyaca uygun çözüm tasarlamayı* önemsiyoruz.",
  ],
  [
    "Sistemi kullanmak için ek donanım yatırımı yapmak gerekiyor mu?",
    "*Hayır. ATIKSOFT mümkün olduğunca mevcut altyapınızla çalışacak şekilde tasarlanmıştır.*\n\nOperasyonun yapısına göre *QR kod, PVC kart veya NFC kart* gibi tanımlama araçları kullanılabilir. Bunun dışında özel bir donanım veya cihaz entegrasyonunu standart olarak zorunlu tutmuyoruz.\n\nİhtiyaç bulunması halinde mevcut kantarlar, tartım ekipmanları, araç sistemleri ve farklı saha teknolojileriyle entegrasyon sağlanabilir.",
  ],
  [
    "Kurulum, eğitim ve kullanım sürecinde destek sağlıyor musunuz?",
    "*Evet. İlk kurulumdan günlük kullanıma kadar tüm süreçte kullanıcılarımızın yanındayız.*\n\nSistemin devreye alınması sırasında gerekli yapılandırmaları gerçekleştiriyor, kullanıcı eğitimlerini sağlıyor ve operasyon başladıktan sonra da destek vermeye devam ediyoruz.\n\nHazırladığımız *video içerikleri, kullanıcı kılavuzları ve destek ekibimiz* sayesinde kullanıcıların sisteme hızlı ve kolay şekilde adapte olmasını hedefliyoruz.",
  ],
  [
    "Mevcut kantar ve tartım sistemlerimiz ATIKSOFT ile çalışabilir mi?",
    "*Evet.*\n\nOperasyonun ve kullanılan ekipmanın teknik yapısına bağlı olarak mevcut kantar ve tartım sistemleriyle entegrasyon sağlanabilir.\n\nBöylece tartım verilerinin operasyon kayıtlarıyla eşleştirilmesi ve ilgili verilerin dijital ortamda takip edilmesi mümkün hale gelir.",
  ],
  [
    "ATIKSOFT mevcut kurumsal sistemlerle entegre olabilir mi?",
    "ATIKSOFT, ihtiyaç ve teknik uygunluk doğrultusunda *farklı kurumsal yazılımlar ve veri kaynaklarıyla entegre çalışabilecek esnek bir altyapıya* sahiptir.\n\nEntegrasyon kapsamı; kurumun mevcut sistemleri, operasyon yapısı ve ihtiyaçları değerlendirilerek belirlenir.",
  ],
  [
    "Her kurum aynı ATIKSOFT yapısını mı kullanıyor?",
    "*Hayır.*\n\nAtık yönetimi operasyonları kurumdan kuruma farklılık gösterdiği için ATIKSOFT'un modülleri ve kullanım yapısı da ihtiyaca göre şekillendirilebilir.\n\nAmaç, kullanılmayacak özelliklerle karmaşık bir sistem oluşturmak yerine *kurumun gerçek saha operasyonuna uygun, uygulanabilir ve sürdürülebilir bir yapı* oluşturmaktır.",
  ],
  [
    "ATIKSOFT üzerinden hangi verileri takip edebilir ve raporlayabiliriz?",
    "Operasyonun kapsamına bağlı olarak; *atık miktarları, toplama noktaları, lokasyonlar, araçlar, iş emirleri, tartım kayıtları, operasyon performansı ve saha hareketleri* gibi birçok veri tek platform üzerinden takip edilebilir.\n\nToplanan veriler sayesinde operasyonların daha *ölçülebilir, izlenebilir ve raporlanabilir* hale getirilmesi hedeflenir.",
  ],
];

function FormattedAnswer({ text }) {
  return (
    <>
      {text.split("\n\n").map((paragraph) => (
        <p key={paragraph}>
          {paragraph
            .split(/(\*[^*]+\*)/g)
            .map((part, index) =>
              part.startsWith("*") && part.endsWith("*") ? (
                <strong key={index}>{part.slice(1, -1)}</strong>
              ) : (
                part
              ),
            )}
        </p>
      ))}
    </>
  );
}

function AboutPage() {
  return (
    <div className="about-page">
      <SiteHeader />
      <main>
        <section className="about-hero">
          <div className="container about-hero-grid">
            <div>
              <p className="eyebrow">
                <span /> ATIKSOFT'U TANIYIN
              </p>
              <h1>
                Sahadan doğan teknoloji,
                <br />
                <em>atık yönetimi için güçlü bir dijital altyapı.</em>
              </h1>
              <p>
                ATIKSOFT, 25 yılı aşkın atık sektörü tecrübesinden beslenen saha
                bilgisi ile yazılım teknolojilerini bir araya getiren Saha Atık
                Bilgi Yönetim Platformudur.
              </p>
            </div>
            <div className="about-visual">
              <div className="about-image">
                <img
                  src="/hakkimizda1.jpeg"
                  alt="ATIKSOFT operasyon yönetimi paneli"
                  width={1516}
                  height={834}
                />
              </div>
              <div className="about-visual-tag">
                <strong>25+</strong>
                <span>
                  yıl
                  <br />
                  saha deneyimi
                </span>
              </div>
            </div>
          </div>
        </section>
        <section className="about-intro container">
          <div className="about-intro-heading">
            <div className="about-intro-label">
              <span>01</span>
              <p>HİKAYEMİZ</p>
            </div>
            <h2>
              <span className="about-title-main">Sahadan gelen deneyim,</span>
              <span className="about-title-sub">dijital bir gelecek.</span>
            </h2>
          </div>
          <div className="about-intro-copy">
            <div>
              <p className="about-lead">
                ATIKSOFT, 25 yılı aşkın atık sektörü tecrübesinden beslenen saha
                bilgisi ile yazılım teknolojilerini bir araya getiren Saha Atık
                Bilgi Yönetim Platformudur.
              </p>
              <p>
                Çıkış noktamız yalnızca bir yazılım geliştirmek değildi. Atığın
                sahada nasıl toplandığını, operasyonların hangi noktalarda
                zorlaştığını ve karar vericilerin ihtiyaç duyduğu veriye neden
                çoğu zaman zamanında ulaşamadığını yıllar içerisinde
                gözlemledik. ATIKSOFT bu ihtiyaçtan doğdu.
              </p>
              <p>
                Bugün sahada gerçekleşen operasyonları dijital veriye
                dönüştürüyor; lokasyon, ekipman, araç, personel, atık
                hareketleri ve operasyon kayıtlarını aynı sistem içerisinde
                ilişkilendirerek kurumların süreçlerini daha görünür ve
                yönetilebilir hale getiriyoruz.
              </p>
            </div>
          </div>
        </section>
        <section className="about-stats">
          <div className="container about-stats-grid">
            <div>
              <strong>25+</strong>
              <span>Atık sektöründen gelen deneyim</span>
            </div>
            <div>
              <strong>150+</strong>
              <span>Farklı saha modellerinden edinilen bilgi</span>
            </div>
            <div>
              <strong>950.000+</strong>
              <span>Fiziksel operasyonu anlayan teknoloji</span>
            </div>
            <div>
              <strong>Deneyimden Teknolojiye</strong>
              <span>ATIKSOFT yaklaşımı</span>
            </div>
          </div>
        </section>
        <section className="about-timeline container">
          <div className="about-intro-label">
            <span>02</span>
            <p>GELİŞİMİMİZ</p>
          </div>
          <div className="timeline-list">
            <div className="timeline-item">
              <strong>
                2018 <ArrowRight size={18} aria-hidden="true" />
              </strong>
              <div>
                <h3>Dijitalleşmenin ilk adımları</h3>
                <p>
                  Sahadaki gerçek ihtiyaçların dijital çözümlere
                  dönüştürülmesine yönelik ilk yazılım çalışmaları başladı. İlk
                  ürünümüz “Nereye Atayım?” ile toplama operasyonlarının kayıt
                  altına alınmasıyla başlayan süreç; zaman içerisinde lokasyon,
                  ekipman, araç, personel, tartım, talep ve raporlama gibi
                  farklı alanların sisteme dahil edilmesiyle gelişti.
                </p>
              </div>
            </div>
            <div className="timeline-item">
              <strong>
                2018 <ArrowRight size={18} aria-hidden="true" />
              </strong>
              <div>
                <h3>Ar-Ge ile güçlenen altyapı</h3>
                <p>
                  ATIKSOFT’un teknolojik altyapısının geliştirilmesi amacıyla
                  yürütülen TÜBİTAK 1507 KOBİ Ar-Ge Başlangıç Destek Programı
                  projesi başarıyla tamamlandı. Bu çalışma ile sistemin
                  ölçeklenebilirliği ve farklı operasyonları aynı platform
                  üzerinde yönetebilme kabiliyeti güçlendirildi.
                </p>
              </div>
            </div>
            <div className="timeline-item">
              <strong>
                Bugün <ArrowRight size={18} aria-hidden="true" />
              </strong>
              <div>
                <h3>Atık Bilgi Yönetim Platformu</h3>
                <p>
                  Bugün ATIKSOFT; belediyelerden lisanslı atık yönetimi
                  firmalarına, sanayi kuruluşlarından zincir işletmelere kadar
                  farklı operasyon modellerinin dijital olarak yönetilebilmesi
                  için geliştirilmeye devam ediyor. Mobil ve masaüstü
                  uygulamalar üzerinden sahadan gelen veriler merkezi olarak
                  izlenebiliyor; farklı sistem ve donanımlarla entegrasyonlar
                  sayesinde veri akışının kesintisiz hale getirilmesi
                  hedefleniyor.
                </p>
              </div>
            </div>
          </div>
        </section>
        <section className="about-mission">
          <div className="container about-mission-inner">
            <div>
              <p className="section-kicker light">03 / NEDEN ATIKSOFT?</p>
              <h2>
                Çünkü teknolojiyi
                <br />
                <em>sahanın gerçeklerine göre geliştiriyoruz.</em>
              </h2>
            </div>
            <div className="about-mission-copy">
              <p>
                ATIKSOFT’un farkı yalnızca sahip olduğu fonksiyonlarda değil,
                ürünün nasıl geliştirildiğinde yatıyor. Bir sürücünün sahada
                yaptığı işlem, bir ekipmanın doluluk bilgisi, bir işletmenin
                atık kaydı veya yöneticinin ihtiyaç duyduğu rapor bizim için
                aynı sistemin parçalarıdır. Bu nedenle ürün geliştirme sürecinde
                önce operasyonu anlamaya, ardından teknolojiyi bu ihtiyaca göre
                şekillendirmeye odaklanıyoruz. Amacımız daha fazla ekran veya
                daha fazla özellik üretmek değil. Doğru verinin, doğru zamanda
                ve doğru kullanıcıya ulaşmasını sağlamak.
              </p>
              <div className="about-mission-closing">
                <p className="section-kicker light">YARIN İÇİN BUGÜN</p>
                <h3>Sahayı biliyoruz. Veriyi anlamlandırıyoruz.</h3>
                <p>
                  Atık yönetiminde artan izlenebilirlik, sürdürülebilirlik ve
                  raporlama ihtiyaçları; kurumların güvenilir veriye olan
                  ihtiyacını her geçen gün artırıyor. Biz ATIKSOFT’u bu
                  dönüşümün dijital altyapılarından biri haline getirmek için
                  geliştiriyoruz. Kamu kurumları için daha görünür ve
                  ölçülebilir süreçler, özel sektör için daha kontrollü
                  operasyonlar, atık yönetimi firmaları için ise daha güçlü saha
                  yönetimi sağlamayı hedefliyoruz. Atık yönetimini sahadan
                  yönetime kadar daha izlenebilir, ölçülebilir ve yönetilebilir
                  hale getiriyoruz.
                </p>
              </div>
            </div>
          </div>
        </section>
        <AboutCatalogs />
      </main>
    </div>
  );
}

function PartnersPage() {
  const focusAreas = [
    "Tartım ve kayıt",
    "Lokasyon bazlı takip",
    "İş emri yönetimi",
    "Araç ve filo takibi",
    "Performans analizi",
    "Raporlama",
  ];

  return (
    <div className="partners-page">
      <SiteHeader />
      <main>
        <section className="partner-hero">
          <div className="container partner-hero-grid">
            <div className="partner-hero-copy">
              <p className="eyebrow">
                <span /> ÇÖZÜM ORTAKLIĞI
              </p>
              <h1>
                Sahadaki güç,
                <br />
                <em>dijitalde izlenebilirlik.</em>
              </h1>
              <p>REMİ Geri Dönüşüm Araçları × ATIKSOFT</p>
              <a
                className="light-button"
                href="/partners/bilgi-notu.pdf"
                target="_blank"
                rel="noreferrer"
              >
                İş birliği dosyasını inceleyin <ExternalLink size={16} />
              </a>
            </div>
            <div className="partner-hero-media">
              <img
                src="/partners/adsiz-tasarim.png"
                alt="ATIKSOFT ve REMİ çözüm ortaklığı"
              />
            </div>
          </div>
        </section>
        <section className="partner-intro container">
          <div className="partner-logo-card">
            <img
                src="/partners/ekran-resmi.png"
              alt="REMİ Geri Dönüşüm Araçları"
            />
            <span>Çözüm ortağımız</span>
          </div>
          <div className="partner-copy">
            <p className="section-kicker">REMİ × ATIKSOFT</p>
            <h2>
              Birbirini tamamlayan
              <br />
              <span>iki güçlü uzmanlık.</span>
            </h2>
            <p>
              REMİ Geri Dönüşüm Araçları’nın geri dönüşüm araçları, ekipmanları
              ve saha operasyonlarındaki deneyimini, ATIKSOFT’un dijital atık
              yönetimi ve izlenebilirlik altyapısıyla bir araya getiriyoruz.
            </p>
            <p>
              Gerçekleştirdiğimiz çözüm ortaklığı ile atık toplama ve taşıma
              operasyonlarının; tartım, lokasyon bazlı takip, iş emri yönetimi,
              araç ve filo takibi, performans analizi ve raporlama süreçleriyle
              daha bütüncül ve ölçülebilir şekilde yönetilebilmesini
              hedefliyoruz.
            </p>
          </div>
        </section>
        <section className="partner-focus">
          <div className="container">
            <div className="partner-focus-heading">
              <div>
                <p className="section-kicker light">ORTAK ÇÖZÜMÜMÜZ</p>
                <h2>
                  Fiziksel operasyon
                  <br />
                  <em>+ dijital yönetim.</em>
                </h2>
              </div>
              <p>
                Atık yönetiminin sahadaki gücünü, karar vermeyi kolaylaştıran
                verilerle buluşturuyoruz.
              </p>
            </div>
            <div className="partner-focus-grid">
              {focusAreas.map((area, index) => (
                <div key={area}>
                  <span>{String(index + 1).padStart(2, "0")}</span>
                  <strong>{area}</strong>
                </div>
              ))}
            </div>
          </div>
        </section>
        <section className="partner-scenarios container">
          <div>
            <p className="section-kicker">SAHADAN SENARYOLAR</p>
            <h2>
              Her senaryoda
              <br />
              <span>birlikte çalışır.</span>
            </h2>
          </div>
          <div className="scenario-list">
            <p>Ambalaj atığı toplamaları</p>
            <p>Evsel atık operasyonları</p>
            <p>Cam kumbaralar</p>
            <p>Depozito iade noktaları</p>
          </div>
        </section>
        <section className="partner-pdf">
          <div className="container partner-pdf-inner">
            <div>
              <p className="section-kicker light">DETAYLI BİLGİ</p>
              <h2>
                Çözüm ortaklığını
                <br />
                <em>yakından inceleyin.</em>
              </h2>
            </div>
            <a
              className="light-button"
              href="/partners/bilgi-notu.pdf"
              target="_blank"
              rel="noreferrer"
            >
              <FileText size={18} /> PDF dosyasını aç <ExternalLink size={15} />
            </a>
          </div>
        </section>
      </main>
    </div>
  );
}

function SiteHeader() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [activeMenu, setActiveMenu] = useState(null);
  const closeMobile = () => {
    setMobileOpen(false);
    setActiveMenu(null);
  };

  return (
    <header className="site-header">
      <div className="announcement">
        <span>Atık yönetiminin geleceğini birlikte tasarlıyoruz.</span>
        <a href="/#iletisim-form">
          Bize ulaşın <ArrowRight size={14} />
        </a>
      </div>
      <nav className="navbar container">
        <a className="brand" href="/" aria-label="Atiksoft ana sayfa">
          <img src="/logo.png" alt="Atiksoft" />
        </a>
        <button
          className="mobile-toggle"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Menüyü aç/kapat"
        >
          {mobileOpen ? <X /> : <Menu />}
        </button>
        <div className={`nav-links ${mobileOpen ? "is-open" : ""}`}>
          <a className="home-link" href="/" onClick={closeMobile}>
            Ana Sayfa
          </a>
          {navigation.map((item, index) => (
            <div
              className={`nav-item ${item.items ? "has-dropdown" : ""}`}
              key={item.title}
            >
              {item.href ? (
                <a href={item.href} onClick={closeMobile}>
                  {item.title}
                </a>
              ) : (
                <button
                  onClick={() =>
                    setActiveMenu(activeMenu === index ? null : index)
                  }
                >
                  {item.title}
                  <ChevronRight size={15} />
                </button>
              )}
              {item.items && (
                <div
                  className={`dropdown ${activeMenu === index ? "mobile-dropdown" : ""}`}
                >
                  {item.items.map(([label, href]) => (
                    <a href={href} key={label} onClick={closeMobile}>
                      {label}
                      <ArrowRight size={14} />
                    </a>
                  ))}
                </div>
              )}
            </div>
          ))}
          <a className="nav-cta" href="/#iletisim-form" onClick={closeMobile}>
            Demo Talep Et <ArrowRight size={16} />
          </a>
          <a
            className="panel-link"
            href="https://panel.atiksoft.com.tr"
            target="_blank"
            rel="noreferrer"
            onClick={closeMobile}
          >
            Panele Giriş <ArrowRight size={16} />
          </a>
        </div>
      </nav>
    </header>
  );
}

function ReferencesPage() {
  const [activeCategory, setActiveCategory] = useState("Tümü");
  const categories = [
    "Tümü",
    ...new Set(referenceLogos.map((item) => item.category)),
  ];
  const visibleLogos =
    activeCategory === "Tümü"
      ? referenceLogos
      : referenceLogos.filter((item) => item.category === activeCategory);

  return (
    <div className="references-page">
      <SiteHeader />
      <main>
        <section className="partner-inline">
          <div className="container partner-inline-grid">
            <div className="partner-inline-copy">
              <p className="eyebrow">
                <span /> İŞ ORTAĞIMIZ
              </p>
              <h1>
                Sahadaki güç,
                <br />
                <em>dijitalde izlenebilirlik.</em>
              </h1>
              <p>
                <strong>REMİ Geri Dönüşüm Araçları × ATIKSOFT</strong>
              </p>
              <p>
                REMİ Geri Dönüşüm Araçları’nın geri dönüşüm araçları,
                ekipmanları ve saha operasyonlarındaki deneyimini, ATIKSOFT’un
                dijital atık yönetimi ve izlenebilirlik altyapısıyla bir araya
                getiriyoruz.
              </p>
              <p>
                Atık toplama ve taşıma operasyonlarını; tartım, lokasyon bazlı
                takip, iş emri yönetimi, araç ve filo takibi, performans analizi
                ve raporlama süreçleriyle daha bütüncül ve ölçülebilir şekilde
                yönetmeyi hedefliyoruz.
              </p>
              <a
                className="light-button"
                href="/partners/bilgi-notu.pdf"
                target="_blank"
                rel="noreferrer"
              >
                İş birliği dosyasını inceleyin <ExternalLink size={16} />
              </a>
            </div>
            <div className="partner-inline-media">
              <img
                src="/partners/adsiz-tasarim.png"
                alt="ATIKSOFT ve REMİ çözüm ortaklığı"
              />
            </div>
          </div>
        </section>
        <section className="references-hero">
          <div className="container references-hero-inner">
            <div>
              <p className="eyebrow">
                <span /> REFERANSLARIMIZ
              </p>
              <h1>
                Güven, birlikte
                <br />
                <em>büyür.</em>
              </h1>
              <p className="references-lead">
                Atiksoft çözümlerini tercih eden ve daha sürdürülebilir bir
                gelecek için birlikte çalıştığımız kurumlar.
              </p>
            </div>
            <div className="references-hero-stats">
              <div>
                <strong>8</strong>
                <span>Referans kurum</span>
              </div>
              <div>
                <strong>4</strong>
                <span>Farklı kategori</span>
              </div>
              <div>
                <strong>1</strong>
                <span>Ortak hedef</span>
              </div>
            </div>
          </div>
        </section>
        <section className="references-content container">
          <div className="references-section-title">
            <div>
              <p className="section-kicker">REFERANS AĞIMIZ</p>
              <h2>
                Birlikte değer
                <br />
                <span>ürettiğimiz</span> kurumlar.
              </h2>
            </div>
            <p>
              Atiksoft çözümleri; belediyelerden özel kuruluşlara,
              kooperatiflerden teknoloji paydaşlarına kadar geniş bir
              ekosistemde kullanılıyor.
            </p>
          </div>
          <div className="reference-filters">
            {categories.map((category) => (
              <button
                className={activeCategory === category ? "active" : ""}
                onClick={() => setActiveCategory(category)}
                key={category}
              >
                {category}
              </button>
            ))}
          </div>
          <div className="reference-grid">
            {visibleLogos.map((item) => (
              <article className="reference-card" key={item.name}>
                <div className="reference-logo">
                  <img src={item.image} alt={item.name} />
                </div>
                <div className="reference-card-footer">
                  <span>{item.category}</span>
                  <h3>{item.name}</h3>
                </div>
              </article>
            ))}
          </div>
        </section>
        <section className="references-quote">
          <div className="container">
            <Award size={28} />
            <p>
              Her güçlü iş birliği, daha sürdürülebilir bir yarının
              başlangıcıdır.
            </p>
            <a href="#iletisim">
              Siz de ekosistemimize katılın <ArrowRight size={16} />
            </a>
          </div>
        </section>
      </main>
    </div>
  );
}

function PoliciesPage() {
  const [activeCategory, setActiveCategory] = useState("Tümü");
  const categories = [
    "Tümü",
    ...new Set(policies.map((policy) => policy.category)),
  ];
  const visiblePolicies =
    activeCategory === "Tümü"
      ? policies
      : policies.filter((policy) => policy.category === activeCategory);

  return (
    <div className="policies-page">
      <SiteHeader />
      <main>
        <section className="policies-hero">
          <div className="container policies-hero-inner">
            <div>
              <p className="eyebrow">
                <span /> KURUMSAL YÖNETİM
              </p>
              <h1>
                İlkelerimiz,
                <br />
                <em>rehberimizdir.</em>
              </h1>
              <p>
                Şeffaf, güvenilir ve sürdürülebilir bir çalışma kültürü için
                benimsediğimiz politikalar.
              </p>
            </div>
            <div className="policy-hero-mark">
              <ShieldCheck size={52} strokeWidth={1.4} aria-hidden="true" />
              <span>
                ATIKSOFT
                <br />
                <strong>POLİTİKALARI</strong>
              </span>
            </div>
          </div>
        </section>
        <section className="policies-content container">
          <div className="policies-heading">
            <div>
              <p className="section-kicker">POLİTİKALARIMIZ</p>
              <h2>
                Kurumsal yaklaşımımızı
                <br />
                <span>keşfedin.</span>
              </h2>
            </div>
            <p>
              Politika belgelerimizi aşağıdan inceleyebilir veya PDF olarak
              indirebilirsiniz.
            </p>
          </div>
          <div className="policy-filters">
            {categories.map((category) => (
              <button
                className={activeCategory === category ? "active" : ""}
                onClick={() => setActiveCategory(category)}
                key={category}
              >
                {category}
              </button>
            ))}
          </div>
          <div className="policy-list">
            {visiblePolicies.map((policy, index) => (
              <a
                className="policy-item"
                href={encodeURI(policy.file)}
                target="_blank"
                rel="noreferrer"
                key={policy.title}
              >
                <span className="policy-index">
                  {String(index + 1).padStart(2, "0")}
                </span>
                <span className="policy-copy">
                  <small>{policy.category}</small>
                  <strong>{policy.title}</strong>
                </span>
                <span className="pdf-action">
                  <ShieldCheck size={20} strokeWidth={1.5} aria-hidden="true" />
                  <span>PDF</span>
                  <ExternalLink size={14} />
                </span>
              </a>
            ))}
          </div>
        </section>
      </main>
    </div>
  );
}

function DocumentsPage() {
  return (
    <div className="documents-page">
      <SiteHeader />
      <main>
        <section className="documents-hero">
          <div className="container">
            <p className="eyebrow">
              <span /> KURUMSAL BELGELER
            </p>
            <h1>
              Belgelerimiz,
              <br />
              <em>güvencemizdir.</em>
            </h1>
          </div>
        </section>
        <section className="documents-content container">
          <div className="documents-heading">
            <p className="section-kicker">BELGELERİMİZ</p>
            <h2>
              Standartlarımızı
              <br />
              <span>inceleyin.</span>
            </h2>
          </div>
          <div className="documents-grid">
            {documents.map((document) => (
              <article className="document-card" key={document.title}>
                <div className="document-image">
                  <img
                    src={document.image}
                    alt={document.title}
                    draggable="false"
                  />
                </div>
                <h3>{document.title}</h3>
              </article>
            ))}
          </div>
        </section>
      </main>
    </div>
  );
}

function FAQPage() {
  const [openIndex, setOpenIndex] = useState(0);
  return (
    <div className="faq-page">
      <SiteHeader />
      <main>
        <section className="faq-hero">
          <div className="container faq-hero-inner">
            <div>
              <p className="eyebrow">
                <span /> BİLGİ MERKEZİ
              </p>
              <h1>
                Sıkça sorulan
                <br />
                <em>sorular.</em>
              </h1>
              <p>ATIKSOFT hakkında en çok merak edilenleri yanıtladık.</p>
            </div>
            <div className="faq-hero-image">
              <img src="/sss.png" alt="" width={1254} height={1254} />
            </div>
          </div>
        </section>
        <section className="faq-content container">
          <div className="faq-heading">
            <p className="section-kicker">SSS</p>
            <h2>
              Merak ettikleriniz
              <br />
              <span>yanıt bulsun.</span>
            </h2>
          </div>
          <div className="faq-list">
            {faqItems.map(([question, answer], index) => (
              <article
                className={`faq-item ${openIndex === index ? "is-open" : ""}`}
                key={question}
              >
                <button
                  onClick={() =>
                    setOpenIndex(openIndex === index ? null : index)
                  }
                >
                  <span>
                    <small>{String(index + 1).padStart(2, "0")}</small>
                    {question}
                  </span>
                  <b>{openIndex === index ? "−" : "+"}</b>
                </button>
                {openIndex === index && (
                  <div className="faq-answer">
                    <FormattedAnswer text={answer} />
                  </div>
                )}
              </article>
            ))}
          </div>
        </section>
      </main>
    </div>
  );
}

function BlogPage() {
  const [activeCategory, setActiveCategory] = useState("Tümü");
  const [expandedPost, setExpandedPost] = useState(null);
  const categories = ["Tümü", ...new Set(blogPosts.map((post) => post.tag))];
  const visiblePosts =
    activeCategory === "Tümü"
      ? blogPosts
      : blogPosts.filter((post) => post.tag === activeCategory);

  return (
    <div className="blog-page">
      <SiteHeader />
      <main>
        <section className="blog-hero">
          <div className="container blog-hero-inner">
            <div>
              <p className="eyebrow">
                <span /> ATIKSOFT GÜNDEMİ
              </p>
              <h1>
                Son gelişmeler,
                <br />
                <em>yeni fikirler.</em>
              </h1>
              <p>
                Atık yönetimi, teknoloji ve sürdürülebilirlik dünyasından
                Atiksoft haberleri.
              </p>
            </div>
            <div className="blog-hero-image">
              <img
                src="/songelismeler.jpeg"
                alt="ATIKSOFT ekibi"
                width={1600}
                height={710}
              />
            </div>
          </div>
        </section>
        <section className="blog-content container">
          <div className="blog-heading">
            <div>
              <p className="section-kicker">BLOG</p>
              <h2>
                Bizden <span>haberler.</span>
              </h2>
            </div>
            <p>
              Başarılarımızı, etkinliklerimizi ve atık yönetiminin geleceğine
              dair gelişmeleri keşfedin.
            </p>
          </div>
          <div className="blog-filters">
            {categories.map((category) => (
              <button
                className={activeCategory === category ? "active" : ""}
                onClick={() => {
                  setActiveCategory(category);
                  setExpandedPost(null);
                }}
                key={category}
              >
                {category}
              </button>
            ))}
          </div>
          <div className="blog-grid">
            {visiblePosts.map((post) => {
              const isExpanded = expandedPost === post.title;
              return (
                <article
                  className={`blog-card ${isExpanded ? "is-expanded" : ""}`}
                  key={post.title}
                >
                  <div className="blog-card-image">
                    <img src={post.image} alt={post.title} />
                    <span>{post.tag}</span>
                  </div>
                  <div className="blog-card-body">
                    <small>{post.date}</small>
                    <h3>{post.title}</h3>
                    <p>{post.description}</p>
                    <button
                      onClick={() =>
                        setExpandedPost(isExpanded ? null : post.title)
                      }
                    >
                      {isExpanded ? "Daha az göster" : "Yazıyı oku"}{" "}
                      <ArrowRight size={15} />
                    </button>
                  </div>
                </article>
              );
            })}
          </div>
        </section>
        <section className="blog-bottom">
          <div className="container">
            <p className="section-kicker light">GÜNCEL KALIN</p>
            <h2>
              Atık yönetiminin geleceğini
              <br />
              <em>birlikte konuşalım.</em>
            </h2>
            <a className="light-button" href="/#iletisim-form">
              İletişime geçin <ArrowRight size={17} />
            </a>
          </div>
        </section>
      </main>
    </div>
  );
}

const wasteGuideSections = [
  {
    title: "Atık Yönetimi Sadece Atık Toplamak Değildir",
    paragraphs: [
      "Bu bölümde amacımız, “atık yönetimi nasıl yapılır?” sorusuna tek ve standart bir yanıt vermek değil. Çünkü her işletmenin operasyon modeli, saha koşulları, paydaş yapısı, atık türleri ve iş akışları farklıdır; süreçler çoğu zaman kendi dinamikleri içerisinde şekillenir.",
      "Bunun yerine, sahadaki uygulamalarımızdan, geliştirdiğimiz projelerden ve edindiğimiz operasyonel tecrübelerden yola çıkarak atık yönetiminde kritik olduğunu düşündüğümüz bazı temel noktaları paylaşmak istiyoruz.",
      "Özellikle bilgi akışı, saha ve merkez arasındaki iletişim, ölçülebilir veri üretimi, tartım altyapıları, operasyonel verimlilik, bakım süreçleri, paydaş yönetimi ve maliyet görünürlüğü gibi başlıkların; başarılı bir atık yönetimi yapısının önemli parçaları olduğuna inanıyoruz.",
      "Bu nedenle bu bölümde hazır reçeteler sunmak yerine, sahada karşılığı olan gözlemlerimizi, çıkarımlarımızı ve iyi uygulama yaklaşımlarını paylaşacağız.",
      "Atık yönetimi çoğu zaman sahada gerçekleşen toplama, taşıma ve ayrıştırma faaliyetleri üzerinden değerlendirilir. Oysa operasyonun gerçek başarısını belirleyen yalnızca atığın fiziksel olarak bir noktadan başka bir noktaya taşınması değildir. Arka planda bilgi paylaşımı, saha koordinasyonu, araç ve ekipman yönetimi, bakım süreçleri, muhasebe, müşteri iletişimi, stok ve sevk takibi, raporlama ve veri analizi gibi daha geniş bir yapı vardır.",
      "Bu nedenle iyi bir atık yönetimi sistemi yalnızca toplama operasyonunu değil, bu operasyonun çevresindeki bütün iş süreçlerini birlikte ele almalıdır.",
    ],
  },
  {
    title: "Atık Yönetiminde En Kritik Kaynaklardan Biri: Doğru Bilgi",
    paragraphs: [
      "Atık sektörü oldukça emek yoğun bir yapıya sahiptir. Saha personeli, sürücüler, operasyon yöneticileri, tesis çalışanları, müşteriler, alt yükleniciler ve idari ekipler aynı operasyonun farklı noktalarında görev alır.",
      "Bu kadar fazla aktörün bulunduğu bir yapıda operasyon kalitesini belirleyen temel unsurlardan biri doğru bilginin doğru kişiye, doğru zamanda ulaşmasıdır.",
      "Bir toplama talebinin telefonda kalması, ekipman arızasının geç bildirilmesi, aracın değiştiğinin saha personeline ulaşmaması veya tartım bilgisinin daha sonra Excel'e manuel girilmesi; yüzlerce lokasyon ve günlük onlarca operasyon söz konusu olduğunda gereksiz seferlere, zaman kaybına, yanlış planlamaya, eksik kayıtlara, müşteri memnuniyetsizliğine ve artan operasyon maliyetlerine dönüşebilir.",
      "Bu nedenle dijitalleşmenin ilk faydası yalnızca otomasyon değil, kurum içerisindeki bilgi akışının standartlaştırılmasıdır.",
    ],
  },
  {
    title: "Emek Yoğun Bir Sektörde Verimlilik Küçük Detaylarda Başlar",
    paragraphs: [
      "Atık toplama operasyonlarında araç, sürücü ve saha personeli en önemli maliyet kalemleri arasındadır. Bu nedenle bir aracın gereksiz yere yaptığı birkaç kilometre, düşük dolulukla gerçekleştirilen bir sefer veya yanlış planlanan bir toplama sıklığı zaman içerisinde ciddi maliyetlere dönüşebilir.",
      "Verimlilik için yalnızca “kaç toplama yapıldı?” sorusuna bakmak yeterli değildir. Kaç araçla yapıldı, kaç kilometre gidildi, kaç saat sürdü, ne kadar yakıt tüketildi, kaç kilogram atık toplandı ve bu operasyonun gerçek maliyeti ne oldu sorularının da yanıtlanması gerekir.",
      "Bu soruların cevapları olmadan operasyonu geliştirmek çoğu zaman tahmine dayalı hale gelir.",
    ],
  },
  {
    title: "Ölçemediğiniz Atığı Yönetemezsiniz",
    paragraphs: [
      "Atık yönetiminde en değerli verilerden biri atığın cinsi ve miktarıdır. Bir lokasyondan “atık toplandı” bilgisinin gelmesi operasyonun gerçekleştiğini gösterir; ancak yönetim açısından sınırlı bir bilgi sunar.",
      "Buna karşılık hangi lokasyondan, hangi tarihte, hangi atık türünden ve kaç kilogram toplandığı biliniyorsa çok daha farklı analizler yapılabilir.",
      "Bu nedenle tartım sistemlerinin saha operasyonlarıyla entegre edilmesi kritik öneme sahiptir. Araç üstü tartım sistemleri, tesis kantarları veya farklı tartım altyapılarından gelen verilerin doğrudan ilgili operasyonla eşleştirilmesi sayesinde atık miktarları lokasyon bazında izlenebilir.",
      "Bu veri yalnızca çevresel raporlama için değil, ticari kararlar için de önemlidir. Bir müşteriden ne kadar atık çıktığı, hangi sıklıkta toplama gerektiği ve bu operasyon için ne kadar kaynak kullanıldığı bilindiğinde daha gerçekçi maliyet ve fiyatlandırma modelleri oluşturulabilir.",
      "Dolayısıyla doğru tartım verisi yalnızca raporlamanın değil, doğru fiyatlandırmanın da temelidir.",
    ],
  },
  {
    title: "Atık Yönetimi Muhasebeden Bağımsız Değildir",
    paragraphs: [
      "Sahadaki operasyonun sonunda mutlaka finansal bir karşılığı oluşur. Yakıt tüketilir, araç kilometre yapar, personel zaman harcar, ekipman kullanılır, bakım yapılır ve sevkiyat gerçekleştirilir.",
      "Bu nedenle operasyon verisinin muhasebe ve maliyet yönetiminden kopuk olması işletmenin gerçek kârlılığını görmesini zorlaştırır.",
      "Toplanan atık miktarı ile operasyon maliyetinin birlikte değerlendirilmesi; müşteri, lokasyon, rota ve operasyon bazında gerçek maliyetlerin ortaya çıkarılmasını sağlar. Atık yönetimi açısından değerli olan yalnızca “ne kadar topladık?” değil, aynı zamanda “ne kadara topladık?” sorusudur.",
    ],
  },
  {
    title: "Ekipman ve Araç Yönetimi Operasyonun Bir Parçasıdır",
    paragraphs: [
      "Kompaktör, pres, hooklift kasa, konteyner veya toplama aracı çalışmadığında yalnızca bir ekipman arızası yaşanmaz. Doğrudan operasyon aksar.",
      "Bu nedenle bakım, servis ve arıza süreçlerini atık yönetiminin dışında değerlendirmek doğru değildir. Hangi ekipmanın ne zaman bakım gördüğü, hangi aracın daha sık arıza yaptığı, en çok karşılaşılan arızanın ne olduğu veya bir ekipmanın ne kadar süre devre dışı kaldığı operasyon planlaması açısından önemli verilerdir.",
      "Bakım ve arıza kayıtlarının dijital iş emirleriyle yönetilmesi, teknik personelin görevlendirilmesi ve yapılan işlemlerin kayıt altına alınması sayesinde operasyonun teknik tarafı da ölçülebilir hale gelir.",
    ],
  },
  {
    title: "Paydaş ve Müşteri İletişimi de Atık Yönetimidir",
    paragraphs: [
      "Atık operasyonları çoğu zaman tek bir şirketin kendi sınırları içerisinde gerçekleşmez. Müşteriler, fabrikalar, mağazalar, belediyeler, lisanslı firmalar, taşeronlar, sürücüler ve saha personeli aynı zincirin farklı parçalarıdır.",
      "Bu nedenle paydaş iletişimi operasyonun ayrılmaz bir parçasıdır.",
      "Müşterinin toplama talebi oluşturabilmesi, ekipman arızasını bildirebilmesi, operasyonun durumunu görebilmesi veya geçmiş atık miktarlarına ulaşabilmesi hem iletişim yükünü azaltır hem de hizmet kalitesini artırır.",
      "Aynı zamanda işletme açısından müşteri ilişkileri kişilerin telefonlarında veya mesaj geçmişlerinde değil, kurumsal bir sistem içerisinde kayıtlı hale gelir.",
    ],
  },
  {
    title: "İyi Atık Yönetimi, Bütünsel Yönetimdir",
    paragraphs: [
      "Modern atık yönetimi yalnızca sahada bir aracın bir konteyneri boşaltmasından ibaret değildir. Başarılı bir operasyon; saha yönetimi + veri + iletişim + lojistik + ekipman + bakım + muhasebe + müşteri ilişkileri + raporlama birlikte yönetildiğinde ortaya çıkar.",
      "Dijitalleşmenin gerçek değeri de tam olarak burada başlar. Amaç yalnızca kağıt formları dijitale taşımak değil; kurum içerisinde daha hızlı bilgi paylaşımının sağlandığı, operasyonların ölçülebildiği ve kararların gerçek saha verisine dayanarak alınabildiği bir sistem oluşturmaktır.",
      "Çünkü atık yönetiminde en büyük verimlilik çoğu zaman daha fazla toplama yapmaktan değil, mevcut operasyonu daha doğru bilgiyle yönetmekten gelir.",
    ],
  },
];

const researchFocusAreas = [
  "Saha operasyonlarının dijitalleştirilmesi",
  "Mobil veri toplama ve doğrulama",
  "Ekipman ve araçların dijital takibi",
  "Atık hareketlerinin izlenebilirliği",
  "Veri analizi ve performans raporlaması",
  "Karbon ve sürdürülebilirlik göstergelerinin hesaplanması",
  "Farklı yazılım, cihaz ve kamu sistemleriyle entegrasyon",
];

const reportingSections = [
  {
    title: "Saha Verisini Ölçülebilir Performansa Dönüştürün",
    paragraphs: [
      "AtıkSoft ile toplama operasyonlarından araç kullanımına, atık miktarlarından ekipman hareketlerine kadar sahada oluşan verileri tek bir raporlama altyapısında birleştirin.",
      "Atıkların hangi lokasyondan, hangi tarihte, hangi türde ve ne kadar miktarda çıktığını takip edin; operasyonel verileri çevresel performans, maliyet ve sürdürülebilirlik göstergeleriyle birlikte değerlendirin. Böylece yalnızca geçmiş operasyonları görüntülemekle kalmayın; kurumunuzun atık yönetimi performansını ölçülebilir, karşılaştırılabilir ve raporlanabilir hale getirin.",
    ],
  },
  {
    title: "Atık Verilerini Detaylı Olarak Raporlayın",
    paragraphs: [
      "Sistem içerisinde oluşan verileri farklı kırılımlarda analiz edin.",
    ],
    list: [
      "Atık türü",
      "Kilogram / ton / adet",
      "Lokasyon",
      "Tesis veya müşteri",
      "Tarih ve dönem",
      "Toplama sıklığı",
      "Araç ve sürücü",
      "Saha personeli",
      "Rota ve sefer",
      "Ekipman",
      "Operasyon süresi",
    ],
    after: [
      "gibi bilgiler üzerinden özelleştirilmiş raporlar oluşturun.",
      "Günlük, haftalık, aylık veya yıllık dönemleri karşılaştırarak atık oluşumundaki ve saha operasyonlarındaki değişimleri görünür hale getirin.",
    ],
  },
  {
    title: "Lokasyon Bazlı Atık Performansını İzleyin",
    paragraphs: [
      "Farklı mağaza, fabrika, tesis, kampüs, belediye bölgesi veya diğer operasyon noktalarının atık performanslarını ayrı ayrı değerlendirin.",
      "Örneğin; hangi lokasyondan ne kadar kağıt, plastik, cam, metal veya evsel atık çıktığını aylık ve yıllık olarak takip edin. Lokasyonların birbirleriyle karşılaştırılması sayesinde yüksek atık oluşumu bulunan noktalar, geri dönüşüm performansı ve toplama ihtiyaçları daha kolay belirlenebilir.",
    ],
  },
  {
    title: "Operasyonel Verimliliği Ölçün",
    paragraphs: [
      "Atık miktarlarını araç, rota, personel ve operasyon verileriyle birlikte değerlendirin. Sefer sayısı, kilometre, operasyon süresi, yakıt tüketimi ve toplanan atık miktarı gibi göstergeleri bir araya getirerek saha operasyonlarının verimliliğini analiz edin.",
      "Bu sayede yalnızca “ne kadar atık toplandı?” değil; bu atığın kaç seferde, ne kadar kaynak kullanılarak ve hangi maliyetle toplandığı da ölçülebilir hale gelir.",
    ],
  },
  {
    title: "Sıfır Atık Performansını Dijital Olarak Takip Edin",
    paragraphs: [
      "Kağıt, plastik, cam, metal, organik, evsel ve diğer atık türlerini ayrı ayrı izleyerek kurumunuzun sıfır atık çalışmalarına veri altyapısı oluşturun.",
      "Lokasyon ve dönem bazında toplam oluşan atık, ayrı toplanan atık miktarı, geri dönüştürülebilir atık miktarı, atık türlerinin dağılımı, toplama sıklıkları ve yıllar arasındaki değişimler gibi göstergeleri takip edin. Böylece sıfır atık çalışmaları sahadan gelen gerçek verilerle ölçülen bir performans modeline dönüşür.",
    ],
  },
  {
    title: "Karbon Ayak İzi ve Çevresel Etkiyi Değerlendirin",
    paragraphs: [
      "Araç kilometresi, yakıt tüketimi, taşıma operasyonları ve toplanan atık miktarlarını çevresel performans verileriyle ilişkilendirin.",
      "Atık toplama ve lojistik faaliyetlerinden kaynaklanan karbon ayak izi verilerini analiz ederek sürdürülebilirlik ve Scope 3 raporlama çalışmalarına veri sağlayın. Farklı rota, araç veya operasyon modellerinin çevresel etkilerini karşılaştırın.",
    ],
  },
  {
    title: "Yönetim Panelleri ve Özelleştirilmiş Raporlar Oluşturun",
    paragraphs: [
      "Farklı kullanıcıların ihtiyaç duyduğu verileri tek bir raporlama ekranında görüntüleyin. Yönetim, operasyon ekipleri, müşteriler veya sürdürülebilirlik birimleri için farklı rapor ve gösterge panelleri oluşturulabilir.",
      "Veriler Excel ve diğer raporlama formatlarında dışa aktarılabilir; kurum içi analizlerde ve paydaş raporlamalarında kullanılabilir.",
    ],
  },
  {
    title: "Uygulama Örnekleri",
    paragraphs: [
      "Kurumsal sıfır atık performansının takibi: Bir şirketin farklı tesis veya şubelerinde oluşan atık miktarlarını aylık ve yıllık olarak takip edin; lokasyonların geri dönüşüm performansını tek merkezden görüntüleyin.",
      "Belediye ve bölge bazlı atık analizi: Mahalle, bölge veya rota bazında toplanan evsel ve geri dönüştürülebilir atık miktarlarını; toplama sıklıkları, araç seferleri ve tonaj verileriyle birlikte değerlendirin.",
      "Operasyon maliyeti ve çevresel performans analizi: Araçların seferlerini, kilometrelerini, yakıt tüketimlerini ve topladıkları atık miktarlarını birlikte değerlendirerek maliyet ve karbon ayak izi açısından daha verimli operasyon modelleri oluşturun.",
    ],
  },
  {
    title: "Veriyi Raporlamaktan Daha Fazlasını Yapın",
    paragraphs: [
      "AtıkSoft ile sahada oluşan veriyi yalnızca arşivlemeyin; ölçün, karşılaştırın, analiz edin ve karar alma süreçlerinde kullanın.",
      "Atık miktarı, lokasyon, araç, rota, personel, maliyet ve çevresel performans verilerinin aynı altyapıda birleşmesi sayesinde kurumunuzun atık yönetimi ve sürdürülebilirlik çalışmalarını gerçek saha verileriyle yönetin.",
    ],
  },
];

const householdSections = [
  {
    title: "Evsel Atık Toplama Operasyonlarını Dijital Olarak Yönetin",
    paragraphs: [
      "İster ilçe belediyesi tarafından doğrudan yürütülen operasyonlarda, ister belediye adına çalışan sözleşmeli veya lisanslı firmalarda; araç, rota, konteyner, saha personeli, tartım ve toplama verilerini tek platform üzerinden yönetin.",
      "Sensör teknolojileri, mobil saha uygulaması, tartım altyapıları ve operasyon doğrulama yöntemleri sayesinde hangi konteynerin ne zaman boşaltıldığı, hangi araç tarafından hizmet verildiği, ne kadar atık toplandığı ve sahadaki gerçek durumun ne olduğu kayıt altına alınabilir.",
    ],
  },
  {
    title: "Konteyner Bazlı Toplama Doğrulaması Yapın",
    paragraphs: [
      "Sahadaki konteynerleri dijital olarak tanımlayın ve toplama operasyonlarını konteyner bazında takip edin. Sensör teknolojileri ve saha doğrulama yöntemleri sayesinde aşağıdaki bilgileri kayıt altına alın:",
    ],
    list: [
      "Hangi konteynerin boşaltıldığı",
      "İşlemin hangi tarihte ve saatte gerçekleştiği",
      "Hangi araç ve ekip tarafından gerçekleştirildiği",
      "Konteynerin bulunduğu lokasyon",
      "Toplanan atığın kilogram / ton bilgisi",
      "Tartım sonucu",
      "Toplama işleminin gerçekleşip gerçekleşmediği",
    ],
    after: [
      "Bu sayede yalnızca aracın ilgili sokaktan geçtiği değil, ilgili konteynere gerçekten hizmet verildiği ve ne kadar atık toplandığı doğrulanabilir.",
    ],
  },
  {
    title: "Sensör ve Tartım Teknolojileri ile Sahayı Görünür Hale Getirin",
    paragraphs: [
      "Konteynerlerden ve saha ekipmanlarından alınan sensör verilerini operasyon kayıtlarıyla ilişkilendirin. Araç üstü tartım sistemleri veya diğer tartım altyapıları sayesinde toplanan evsel atık miktarlarını operasyon, araç, konteyner veya bölge bilgileriyle eşleştirin.",
    ],
    list: [
      "Konteyner boşaltım bilgisi",
      "Lokasyon",
      "Araç ve personel",
      "Toplanan kilogram / ton miktarı",
      "Tarih ve saat",
      "Operasyon durumu",
    ],
    after: [
      "Bu yapı sayesinde evsel atık operasyonları yalnızca “toplandı / toplanmadı” seviyesinde değil, ölçülebilir miktar verileriyle takip edilir.",
    ],
  },
  {
    title: "Rota ve İş Emirlerini Dinamik Olarak Yönetin",
    paragraphs: [
      "Toplama noktalarını araç ve saha ekipleriyle eşleştirerek günlük rotaları AtıkSoft üzerinden yönetin. Yetkili kullanıcılar saha ekiplerine dijital iş emirleri oluşturabilir; yeni talepler, araç değişiklikleri veya saha koşullarına göre operasyon planları güncellenebilir.",
      "Rota performansı değerlendirilirken gerçekleşen sefer sayısı, hizmet verilen konteyner sayısı, toplanan toplam atık miktarı, kilometre, operasyon süresi ve araç doluluk ve kapasite kullanımı gibi bilgiler birlikte analiz edilebilir.",
    ],
    after: [
      "Böylece hangi rotanın yalnızca kaç kilometre sürdüğü değil, o rota sonucunda kaç kilogram veya ton atık toplandığı da görülebilir.",
    ],
  },
  {
    title: "Tahminleme Modülü ile Toplama İhtiyacını Öngörün",
    paragraphs: [
      "Geçmiş toplama ve tartım verilerini kullanarak konteyner ve bölge bazında oluşabilecek toplama ihtiyacını analiz edin. Toplama sıklığı, geçmiş atık miktarları, lokasyon, dönemsel değişimler ve operasyon verileri değerlendirilerek belirli noktaların ne zaman yeniden hizmete ihtiyaç duyabileceğine ilişkin tahminler oluşturulabilir.",
      "Böylece operasyonlar yalnızca sabit takvimlere göre değil, geçmişte ölçülen gerçek atık miktarlarına ve öngörülen ihtiyaca göre planlanabilir.",
    ],
  },
  {
    title: "Sahadaki Gerçek Durumu Fotoğrafla Kayıt Altına Alın",
    paragraphs: [
      "Saha personeli operasyon sırasında mobil uygulama üzerinden fotoğraf ve açıklama kaydı oluşturabilir. Taşmış konteyner, uygunsuz atık bırakılması, erişim problemi, hasarlı ekipman veya diğer saha durumları fotoğrafla birlikte ilgili lokasyona ve operasyona bağlanabilir.",
      "Böylece sahada karşılaşılan durumlar yalnızca sözlü bildirim olarak kalmaz; tarih, lokasyon, tartım, operasyon ve görsel kayıt ile birlikte kurumsal hafızaya dönüşür.",
    ],
  },
  {
    title: "Belediye ve Yüklenici Operasyonlarını Aynı Sistemden İzleyin",
    paragraphs: [
      "AtıkSoft, evsel atık operasyonunun belediye tarafından kendi araçlarıyla yürütülmesi veya hizmetin sözleşmeli firmalara verilmesi fark etmeksizin kullanılabilir.",
      "Belediye; kendi ekipleriyle birlikte yüklenici firmaların araçlarını, rotalarını, konteyner boşaltımlarını, sefer sayılarını, toplanan kilogram / ton miktarlarını, tartım kayıtlarını, saha fotoğraflarını, operasyon sürelerini, hizmet verilen bölgeleri ve operasyon performansını aynı sistem üzerinden takip edebilir.",
      "Bu sayede hizmetin kim tarafından gerçekleştirildiğinden bağımsız olarak operasyon verisi ortak bir dijital altyapıda toplanır.",
    ],
  },
  {
    title: "Uygulama Örnekleri",
    paragraphs: [
      "İlçe Belediyesi Evsel Atık Operasyonları: Mahalle ve sokak bazında konteyner boşaltımlarını takip edin. Hangi konteynere hangi araç tarafından hizmet verildiğini doğrulayın; günlük seferleri, rotaları, saha fotoğraflarını ve tartım kayıtlarını tek sistem üzerinden görüntüleyin. Araç üstü tartım sistemleriyle birlikte kullanıldığında hangi mahalle veya bölgeden hangi tarihte kaç kilogram / ton evsel atık toplandığı ölçülebilir hale gelir.",
      "Sözleşmeli Firma Performansının Takibi: Belediye adına evsel atık toplama hizmeti sağlayan firmaların gerçekleştirdiği operasyonları dijital olarak doğrulayın. Planlanan rota ile gerçekleşen operasyonu, hizmet verilen konteynerleri, toplanan atık miktarlarını, tartım sonuçlarını ve saha kayıtlarını karşılaştırarak hizmet performansını ölçülebilir hale getirin.",
      "Tahminleme ile Dinamik Toplama Planlaması: Geçmiş konteyner boşaltımları ve tartım verileri üzerinden daha hızlı dolan veya daha fazla atık üreten bölgeleri belirleyin. Tahminleme sonuçlarını rota planlaması ile birlikte değerlendirerek araç ve ekiplerin ihtiyaç bulunan bölgelere daha doğru zamanda yönlendirilmesini sağlayın.",
    ],
  },
];

const integrationSections = [
  {
    title: "Mevcut Sistemlerinizi AtıkSoft ile Birbirine Bağlayın",
    paragraphs: [
      "AtıkSoft, saha operasyonlarında oluşan verilerin yalnızca kendi içerisinde kalmadığı; farklı kurumsal yazılımlar, kamu sistemleri ve dijital evrak altyapıları ile veri alışverişi yapabildiği bütünleşik bir yapı sunar.",
      "DBYS, araç takip sistemleri, ERP yazılımları, e-irsaliye çözümleri ve işletmeye özel diğer dijital sistemlerle gerçekleştirilen entegrasyonlar sayesinde manuel veri girişleri azaltılır, aynı bilginin birden fazla sisteme tekrar tekrar girilmesinin önüne geçilir. İşletmenin mevcut dijital altyapısı korunurken AtıkSoft, saha ile merkez arasındaki veriyi birbirine bağlayan operasyon katmanı olarak konumlanır.",
    ],
  },
  {
    title: "DBYS Entegrasyonu",
    paragraphs: [
      "Depozito operasyonlarında sahada oluşan verileri AtıkSoft üzerinden yönetin ve ilgili kayıtları entegrasyon kapsamında DBYS ile paylaşın.",
      "Entegrasyon sayesinde saha personelinin aynı toplama işlemini farklı uygulamalarda tekrar oluşturmasına gerek kalmaz. Toplama, adet, lokasyon, görev ve operasyon kayıtları AtıkSoft üzerinden oluşturulurken gerekli veriler ilgili merkezi sisteme aktarılabilir.",
      "Bu yapı sahadaki operasyon ile depozito bilgi sistemi arasında dijital bir veri köprüsü oluşturur.",
    ],
  },
  {
    title: "Araç Takip Sistemi Entegrasyonu",
    paragraphs: [
      "Mevcut araç takip sistemlerinizden gelen konum ve araç verilerini AtıkSoft operasyonlarıyla birleştirin.",
      "Araçların canlı konumları, gerçekleşen güzergâhları ve saha görevleri AtıkSoft içerisindeki rota ve iş emirleri ile birlikte değerlendirilebilir. Böylece araç takip verisi yalnızca harita üzerinde görüntülenen bir konum bilgisi olmaktan çıkar; doğrudan atık toplama ve saha operasyonları ile ilişkilendirilir.",
    ],
  },
  {
    title: "ERP ve Kurumsal Yazılım Entegrasyonları",
    paragraphs: [
      "AtıkSoft'u işletmenizde kullanılan ERP, muhasebe, stok, müşteri yönetimi veya diğer kurumsal yazılımlarla entegre edin.",
      "Müşteri, lokasyon, ürün, stok, operasyon veya mali kayıtlar ihtiyaç doğrultusunda sistemler arasında paylaşılabilir. Bu sayede farklı departmanların aynı veriyi ayrı ayrı oluşturması yerine, mevcut kurumsal altyapılar arasında daha tutarlı ve otomatik bir veri akışı sağlanabilir.",
    ],
  },
  {
    title: "E-İrsaliye ve Dijital Evrak Entegrasyonu",
    paragraphs: [
      "Saha operasyonları sırasında oluşan taşıma ve sevk kayıtlarını dijital evrak süreçleriyle ilişkilendirin.",
      "E-irsaliye entegrasyonları sayesinde operasyon sırasında oluşan araç, müşteri, miktar ve sevk bilgileri ilgili dijital belge süreçlerinde kullanılabilir. Böylece operasyon verisi ile ticari veya resmi evrak süreçleri arasındaki manuel bilgi aktarımı azaltılır.",
    ],
  },
  {
    title: "Dijital Belge ve Evrak Takibi",
    paragraphs: [
      "Araç, personel, ekipman veya operasyonlara ilişkin belgeleri dijital olarak takip edin.",
    ],
    list: [
      "Araç belgeleri",
      "Sigorta ve muayene kayıtları",
      "Personel evrakları",
      "Yetki ve faaliyet belgeleri",
      "Servis ve bakım kayıtları",
      "Operasyona özel dokümanlar",
    ],
    after: [
      "gibi belgeleri ilgili kayıtlarla ilişkilendirin ve geçerlilik sürelerini merkezi olarak yönetin. Bu sayede fiziksel dosya ve dağınık belge takibi yerine daha düzenli ve erişilebilir bir dijital arşiv oluşturun.",
    ],
  },
  {
    title: "İşletmenize Özel Entegrasyonlar Geliştirin",
    paragraphs: [
      "Her işletmenin operasyon yapısı ve kullandığı dijital sistemler farklı olabilir. AtıkSoft, ihtiyaç doğrultusunda mevcut yazılım ve donanımlarla özel entegrasyon çalışmalarına uygun bir altyapı sunar.",
      "API veya diğer veri paylaşım yöntemleri üzerinden tartım sistemleri, sensörler, araç üstü ekipmanlar, ERP çözümleri, dijital evrak sistemleri ve işletmeye özel yazılımlar AtıkSoft operasyonlarıyla ilişkilendirilebilir.",
      "Bu sayede işletmenin mevcut teknolojik yatırımlarını değiştirmeden, farklı sistemlerin ortak bir operasyon altyapısı içerisinde çalışması sağlanabilir.",
    ],
  },
  {
    title: "Uygulama Örnekleri",
    paragraphs: [
      "Depozito operasyonlarında DBYS entegrasyonu: Saha personeli depozitolu ambalaj toplama işlemlerini yalnızca AtıkSoft mobil uygulaması üzerinden gerçekleştirir. Sahada oluşan ilgili operasyon verileri entegrasyon kapsamında DBYS ile paylaşılır.",
      "Araç takip sistemi ile canlı operasyon takibi: Mevcut ATS altyapısından gelen araç konumlarını AtıkSoft üzerindeki iş emirleri ve toplama rotaları ile eşleştirin. Araçların sahadaki hareketlerini, gerçekleşen rotaları ve görev durumlarını tek operasyon görünümünde takip edin.",
      "ERP ve e-irsaliye ile bütünleşik veri akışı: Toplama veya sevk operasyonunda oluşan müşteri, miktar, araç ve operasyon verilerini kurumsal ERP ve e-irsaliye süreçleriyle ilişkilendirerek sahadan merkez sistemlerine dijital veri akışı oluşturun.",
    ],
  },
  {
    title: "Tekrar Veri Girişini Azaltın, Sistemlerinizi Birbirine Bağlayın",
    paragraphs: [
      "AtıkSoft ile saha operasyonlarını mevcut kurumsal altyapınızdan bağımsız bir yapı olarak değil, onunla entegre çalışan bir sistem olarak yönetin.",
      "DBYS, araç takip sistemleri, ERP çözümleri, e-irsaliye altyapıları ve işletmeye özel diğer dijital sistemleri aynı operasyon zincirinde bir araya getirerek saha ile merkez arasındaki veri akışını sadeleştirin.",
    ],
  },
];

const inventorySections = [
  {
    title: "Envanter, Stok ve Sevk Süreçlerini Bütünsel Olarak Yönetin",
    paragraphs: [
      "AtıkSoft ile yalnızca sahadaki ekipmanları değil; tesis içerisinde veya tesis dışında bulunan atık, geri dönüştürülebilir malzeme, yarı mamul ve sevke hazır envanteri de tek platform üzerinden yönetin.",
      "Farklı toplama operasyonlarından tesise gelen malzemeleri tür, miktar, lokasyon ve stok durumu bazında kayıt altına alın. Plastik, kağıt, karton, cam, metal ve diğer atık gruplarının tesis içerisindeki hareketlerini; balyalı, big bag içerisinde, paletli, konteynerli veya işletmenizin kullandığı diğer depolama biçimlerine göre ayrı ayrı takip edin.",
      "Envanterin yalnızca toplam miktarını değil; hangi tesiste veya depo alanında bulunduğunu, hangi operasyondan geldiğini, mevcut durumunu ve gerçekleştirilen stok hareketlerini geriye dönük olarak görüntüleyin.",
      "AtıkSoft envanter yönetimini tesis sınırlarıyla sınırlamaz. Farklı depolarda, müşteri tesislerinde, geçici stok alanlarında veya farklı operasyon noktalarında bulunan malzemeler aynı sistem içerisinde takip edilebilir.",
      "Sevke hazır hale gelen balya, big bag veya diğer malzemelerin çıkış süreçlerini kayıt altına alın; hangi malzemenin, ne kadar miktarda, hangi tesisten ve hangi araçla sevk edildiğini takip edin. Sevkiyat planlamasından araç ve tır yüklemelerine, tartım bilgilerinden sevk edilen stokların sistemden düşülmesine kadar sürecin tamamını aynı veri altyapısında yönetin.",
      "Böylece toplama operasyonlarından tesiste oluşan stoklara, ekipman kullanımından sevkiyata kadar sahanın, tesisin, envanterin ve lojistiğin birlikte yönetildiği bütünsel bir operasyon yapısı oluşturun.",
    ],
  },
  {
    title: "Ekipmanlarınızı Sahada Görünür ve Yönetilebilir Hale Getirin",
    paragraphs: [
      "AtıkSoft ile hooklift kasaları, kompaktörler, presler, konteynerler, kumbaralar ve diğer saha ekipmanlarını tek platform üzerinden yönetin.",
      "Ekipmanları QR kod ve BLE tabanlı sensör teknolojileri ile dijital olarak kimliklendirin; sabit veya hareketli ekipmanların lokasyon, kullanım, bakım, arıza ve operasyon geçmişlerini kayıt altında tutun.",
      "Sensörlerden alınan konum verileri sayesinde ekipmanlar canlı harita üzerinden görüntülenebilir, hareketli ekipmanların son görüldüğü lokasyon bilgisine erişilebilir.",
    ],
  },
  {
    title: "Ekipmanları Dijital Olarak Kimliklendirin",
    paragraphs: [
      "Sahadaki ekipmanları QR kod veya BLE tabanlı sensörler ile dijital envantere dahil edin. Her ekipman için aşağıdaki bilgiler tek kayıt altında tutulabilir:",
    ],
    list: [
      "Ekipman türü",
      "Ekipman kodu",
      "Bulunduğu lokasyon",
      "Atandığı tesis veya müşteri",
      "Kullanım durumu",
      "Son görüldüğü konum",
      "Bakım ve arıza geçmişi",
      "Gerçekleştirilen işlemler",
    ],
  },
  {
    title: "Sensör ile Canlı Harita Üzerinden Takip Edin",
    paragraphs: [
      "BLE tabanlı sensör teknolojileri sayesinde ekipmanların saha içerisindeki hareketlerini ve konum bilgilerini takip edin. AtıkSoft harita ekranı üzerinden ekipmanların güncel veya son görüldüğü lokasyonları görüntüleyin.",
      "Bu yapı özellikle hooklift kasaları, konteynerler ve farklı tesisler arasında hareket eden ekipmanların nerede olduğunun hızlı şekilde belirlenmesini sağlar. Ekipman hareketlerinin kayıt altına alınması; envanter kayıplarının, yanlış lokasyon bilgisinin ve gereksiz saha iletişiminin azaltılmasına yardımcı olur.",
    ],
  },
  {
    title: "QR Kod ile Ekipman İşlemlerini Doğrulayın",
    paragraphs: [
      "Ekipmanın üzerindeki QR kod okutularak bakım, kontrol, arıza, doluluk veya diğer saha işlemleri doğrudan ilgili ekipmanla eşleştirilebilir. Böylece personelin yaptığı işlemler manuel ekipman seçimine ihtiyaç duyulmadan doğru ekipman kaydına aktarılır.",
      "Her ekipmanın zaman içerisinde kendi dijital işlem geçmişi oluşur.",
    ],
  },
  {
    title: "Bakım ve Arıza İş Emirlerini Yönetin",
    paragraphs: [
      "Şirket içerisinde veya müşterilerin tesislerinde bulunan ekipmanlarda oluşan arıza ve bakım ihtiyaçlarını sistem üzerinden yönetin. Arıza bildirimi oluşturulduğunda ilgili teknik personel, bakım ekibi veya sorumlu kişiye dijital iş emri atanabilir.",
      "Bakım sürecinde arıza türü, görevlendirilen personel, müdahale tarihi, yapılan işlem, değiştirilen parça, teknik açıklamalar, bakım ve tamir maliyeti ile iş emri durumu gibi bilgiler kayıt altına alınabilir.",
      "Böylece ekipmanın yalnızca mevcut durumu değil, tüm bakım ve servis geçmişi de izlenebilir hale gelir.",
    ],
    list: [
      "Arıza türü",
      "Görevlendirilen personel",
      "Müdahale tarihi",
      "Yapılan işlem",
      "Değiştirilen parça",
      "Teknik açıklamalar",
      "Bakım ve tamir maliyeti",
      "İş emri durumu",
    ],
  },
  {
    title: "Şirket Dışındaki Ekipman ve Personeli de Takip Edin",
    paragraphs: [
      "Operasyon her zaman şirketin kendi tesisinde gerçekleşmeyebilir. Başka bir fabrika, müşteri tesisi veya saha lokasyonunda kullanılan şirkete ait ekipmanlar ve bu ekipmanlardan sorumlu personel de AtıkSoft üzerinden yönetilebilir.",
      "Ekipmanın hangi tesiste bulunduğu, kim tarafından kullanıldığı, hangi bakım veya servis işlemlerinin gerçekleştirildiği ve ekipman için oluşturulan iş emirleri merkezi olarak takip edilebilir.",
      "Bu sayede şirket sınırları dışında bulunan ekipmanlar da kurumsal envanterin bir parçası olarak yönetilmeye devam eder.",
    ],
  },
  {
    title: "Fiziksel Ekipmanları Dijital Envantere Dönüştürün",
    paragraphs: [
      "AtıkSoft ile ekipmanların yalnızca listesini tutmayın; nerede olduklarını, en son nerede görüldüklerini, kim tarafından kullanıldıklarını, hangi bakım işlemlerinden geçtiklerini ve hangi iş emirlerinin oluşturulduğunu tek platform üzerinden takip edin.",
      "QR kod, sensör, canlı harita ve dijital iş emri altyapısının birlikte çalışması sayesinde saha ekipmanlarını daha görünür, izlenebilir ve yönetilebilir hale getirin.",
    ],
  },
];

const collectionSections = [
  {
    title: "Sahadaki Her Atık Hareketini Dijital Olarak Yönetin",
    paragraphs: [
      "AtıkSoft ile atık toplama operasyonlarını talep oluşumundan saha uygulamasına, tartımdan teslimata kadar tek platform üzerinden yönetin.",
      "Toplama noktaları, saha ekipleri, araçlar, atık türleri ve miktarları operasyon bazında kayıt altına alınır. Telefon, çevrimiçi mesajlaşma uygulamaları, kağıt formlar ve dağınık Excel dosyaları üzerinden yürütülen süreçler izlenebilir, raporlanabilir ve merkezi olarak yönetilebilir bir yapıya dönüşür.",
      "Dinamik iş emri atama yapısı sayesinde günlük operasyonlar ihtiyaçlara göre hızlıca planlanabilir. Ambalaj atıkları, evsel atıklar veya endüstriyel atıklar için operasyonlar ayrı ayrı takip edilebilir; personelin iş emri, lokasyon, işlem süresi ve operasyon bilgileri dijital olarak izlenir.",
    ],
  },
  {
    title: "Toplama Taleplerini Tek Merkezden Yönetin",
    paragraphs: [
      "Müşteri, tesis, mağaza, şube veya diğer atık üretim noktalarından gelen toplama taleplerini sistem üzerinden oluşturun, planlayın ve takip edin.",
      "Talebin hangi lokasyondan geldiğini, hangi atığın alınacağını, planlanan toplama tarihini ve operasyon durumunu tek ekran üzerinden görüntüleyin.",
    ],
    list: [
      "Toplama noktası",
      "Atık türü",
      "Tahmini veya gerçekleşen atık miktarı",
      "Talep tarihi",
      "Planlanan toplama tarihi",
      "Operasyon durumu",
      "Atanan araç ve saha personeli",
      "Operasyon notları",
      "Operasyon başlangıç ve tamamlanma süreleri",
      "Personel ve operasyon performans metrikleri",
      "Araç kilometre ve kullanım bilgileri",
      "Yakıt tüketimi",
      "Operasyona bağlı karbon ayak izi verileri",
      "Fotoğraf ve saha doğrulama kayıtları",
    ],
    after: [
      "Bu yapı sayesinde yalnızca toplama talepleri değil, operasyonun zaman, kaynak ve çevresel performansı da ölçülebilir hale gelir.",
    ],
  },
  {
    title: "Dinamik İş Emirleri ile Sahayı Yönetin",
    paragraphs: [
      "Planlanan operasyonlar yetkili kullanıcı tarafından masaüstü paneli üzerinden ilgili araç, sürücü veya saha personeline iş emri olarak atanabilir.",
      "Gün içerisinde oluşan yeni talepler, değişen saha koşulları veya öncelikli operasyonlar doğrultusunda iş emirleri güncellenebilir ve saha ekiplerine hızlıca yönlendirilebilir.",
      "Saha personeli kendisine atanan görevleri mobil uygulama üzerinden görüntüler ve ilgili saha kayıtlarını doğrudan sistem üzerinden oluşturur. Böylece operasyon merkezi ile saha ekipleri arasındaki telefon ve mesaj trafiği azalırken görevlerin kim tarafından, ne zaman ve hangi lokasyonda gerçekleştirildiği kayıt altına alınır.",
    ],
  },
  {
    title: "Mobil Uygulama ile Sahadan Anlık Veri Toplayın",
    paragraphs: [
      "Saha operasyonları AtıkSoft mobil uygulaması üzerinden anlık olarak kayıt altına alınabilir. Personel toplama noktasına ulaştığında gerekli bilgileri mobil cihaz üzerinden sisteme aktarabilir.",
    ],
    list: [
      "Toplanan atık türü",
      "Atık miktarı",
      "Adet veya kilogram bilgisi",
      "Tartım sonucu",
      "Fotoğraf",
      "Açıklama ve operasyon notu",
      "Tarih ve saat",
      "Lokasyon bilgisi",
      "Toplama ve teslim bilgileri",
      "Doluluk bildirimleri",
      "İş emri başlangıç ve bitiş bilgileri",
      "Operasyonun tamamlanma durumu",
    ],
    after: [
      "Bu sayede saha ile merkez arasındaki bilgi akışı anlık ve kayıtlı hale gelir.",
    ],
  },
  {
    title: "QR, NFC ve Dijital Kimliklendirme ile Doğrulayın",
    paragraphs: [
      "Toplama noktaları, ekipmanlar veya operasyon içerisindeki diğer varlıklar QR kod ve NFC teknolojileri ile dijital olarak kimliklendirilebilir.",
      "Saha personeli ilgili noktada doğrulama yaparak işlemin doğru lokasyonda ve doğru ekipman üzerinde gerçekleştirildiğini kayıt altına alır. Manuel veri girişinden kaynaklanabilecek hatalar azaltılır; geçmiş işlemler geriye dönük olarak incelenebilir.",
    ],
  },
  {
    title: "Tartım Verilerini Operasyonla Eşleştirin",
    paragraphs: [
      "Toplanan atıkların miktarlarını doğrudan ilgili operasyon, müşteri, lokasyon, araç ve atık türü ile ilişkilendirin. Araç üstü tartım sistemleri veya diğer tartım altyapıları ile ağırlık verileri operasyon kayıtlarına dijital olarak aktarılabilir.",
      "Böylece nereden, ne zaman, hangi araçla, hangi personel tarafından, hangi atık türünden ve kaç kilogram toplandığı ölçülebilir ve raporlanabilir hale gelir. Bu veriler operasyonel performans, rota verimliliği, maliyet, kaynak kullanımı ve sürdürülebilirlik raporlarında kullanılabilir.",
    ],
  },
  {
    title: "Farklı Atık Türlerini Aynı Altyapı Üzerinden Yönetin",
    paragraphs: [
      "Atık toplama operasyonları farklı atık grupları ve işletme ihtiyaçlarına göre yapılandırılabilir.",
    ],
    list: [
      "Kağıt ve karton",
      "Plastik",
      "Cam",
      "Metal",
      "Ambalaj atıkları",
      "Evsel atıklar",
      "Endüstriyel atıklar",
      "Diğer geri dönüştürülebilir atık türleri",
    ],
    after: [
      "Farklı operasyon modelleri tek bir dijital altyapı üzerinden yönetilebilir.",
    ],
  },
  {
    title: "Operasyonları Baştan Sona İzleyin",
    paragraphs: [
      "Her toplama operasyonunun mevcut durumunu sistem üzerinden takip edin.",
    ],
    list: [
      "Talep oluşturma: Atık toplama talebi sisteme kaydedilir.",
      "Planlama ve iş emri atama: Araç, sürücü ve saha ekibi belirlenir; dijital iş emri atanır.",
      "Saha operasyonu: Personel görevi mobil uygulamadan görüntüler ve toplama işlemini gerçekleştirir.",
      "Doğrulama ve veri kaydı: Atık türü, miktarı, tartım sonucu, fotoğraf ve lokasyon bilgileri aktarılır.",
      "Teslim ve operasyon kapanışı: Teslim noktası, gerçekleşen miktar ve operasyon sonucu kaydedilir.",
      "Performans ve raporlama: Operasyonlar lokasyon, müşteri, atık türü, araç, personel ve tarih bazında raporlanır.",
    ],
  },
  {
    title: "Uygulama Örnekleri",
    paragraphs: [
      "Zincir mağazalarda atık toplama: Yüzlerce veya binlerce mağazadan gerçekleştirilen operasyonları merkezi olarak yönetin; talepleri, araçları, saha ekiplerini ve atık miktarlarını tek sistemde takip edin.",
      "Sanayi tesislerinden planlı atık toplama: Fabrika, üretim tesisi ve sanayi kuruluşlarından düzenli veya talebe bağlı operasyonları dijitalleştirin; tesis bazında atık oluşumunu, toplama sıklığını ve performansı analiz edin.",
      "Sokak toplayıcıları ve kooperatif operasyonları: Saha aktörlerinin faaliyetlerini, atığın türünü, miktarını, teslim noktasını, işlem zamanını ve personeli dijital olarak izleyin.",
    ],
  },
  {
    title: "Tek Operasyondan Kurumsal Hafızaya",
    paragraphs: [
      "AtıkSoft yalnızca operasyonların gerçekleştirildiğini kayıt altına almaz; sahada oluşan veriyi operasyonel kararların alınabileceği anlamlı bilgiye dönüştürür.",
      "Toplama operasyonlarını merkezi olarak yönetin, dinamik iş emirleri oluşturun, saha görevlerini takip edin, toplanan atıkları lokasyon ve tür bazında izleyin, fotoğraf ve konumla doğrulayın. Araç, personel, süre, yakıt ve karbon ayak izi verilerini analiz ederek kurumsal bir veri altyapısı oluşturun.",
      "Dağınık saha bilgisinin tek sistemde toplanması sayesinde geçmiş operasyonlar karşılaştırılabilir, verimsiz süreçler fark edilebilir ve gelecek operasyonlar gerçek saha verisine dayanarak planlanabilir.",
    ],
  },
];

const logisticsSections = [
  {
    title: "Araç Arıza ve Bakım Analizi",
    paragraphs: [
      "Araçların bakım ve arıza geçmişlerini tek noktada toplayarak filo genelinde karşılaştırmalı analizler oluşturun.",
      "Belirli bir dönem içerisinde en fazla arıza kaydı bulunan aracı, en sık karşılaşılan arıza türünü, araç başına bakım ve tamir maliyetini, tekrarlayan arızaları, araçların serviste geçirdiği süreyi ve gerçekleştirilen bakım ile parça değişimlerini analiz edin.",
      "Bu sayede yalnızca oluşan arızaları kayıt altına almakla kalmayın; hangi araçların daha fazla bakım ihtiyacı oluşturduğunu ve filoda en sık karşılaşılan teknik problemlerin neler olduğunu görünür hale getirin.",
    ],
  },
  {
    title: "Yakıt Tüketimi ve Araç Maliyetlerini Takip Edin",
    paragraphs: [
      "Araçların yakıt, bakım, servis, tamir ve diğer giderlerini araç özelinde kayıt altına alın.",
      "Yakıt tüketimini kilometre, sefer sayısı ve toplanan atık miktarıyla birlikte değerlendirin. Böylece araçların gerçek operasyon maliyetleri görülebilir; dönemler veya araçlar arasında performans karşılaştırmaları yapılabilir.",
    ],
  },
  {
    title: "Araç Belgelerini Dijital Olarak Takip Edin",
    paragraphs: [
      "Araçlara ait operasyonel ve resmi belgeleri tek noktada takip edin. Geçerlilik ve yenileme tarihlerini sistem üzerinden yönetin.",
    ],
    list: [
      "Araç ruhsatı",
      "Trafik sigortası",
      "Kasko",
      "Araç muayenesi",
      "Egzoz emisyon ölçümü",
      "Yetki ve faaliyet belgeleri",
      "İşletmeye özel diğer araç belgeleri",
    ],
  },
  {
    title: "Periyodik Bakım, Arıza ve Servis Süreçlerini Yönetin",
    paragraphs: [
      "Araçların periyodik bakım, arıza, tamir ve servis süreçlerini dijital olarak takip edin. Planlanan bakım veya oluşan arıza için ilgili teknik personele, bakım sorumlusuna veya yetkili kişilere dijital iş emri atayın.",
    ],
    list: [
      "Bakım veya arıza kaydı: Araç için yapılması gereken işlem sisteme kaydedilir.",
      "İş emri atama: Bakım veya tamiri gerçekleştirecek sorumlu kişi ya da personele görev atanır.",
      "İşlem takibi: Bakım, servis, parça değişimi ve yapılan işlemler kayıt altına alınır.",
      "Maliyet ve kapanış: İşçilik, servis ve parça maliyetleri ilgili araçla ilişkilendirilerek işlem tamamlanır.",
    ],
    after: [
      "Bu sayede her aracın bakım ve arıza geçmişi geriye dönük olarak görüntülenebilir.",
    ],
  },
  {
    title: "Araç Takip Sistemi Entegrasyonu ile Canlı Filo Takibi",
    paragraphs: [
      "Mevcut araç takip ve GPS sistemleri ile gerçekleştirilen entegrasyonlar sayesinde operasyondaki araçları canlı olarak takip edin.",
      "Araçların anlık konumlarını, gerçekleştirdikleri güzergâhları ve saha operasyonlarını AtıkSoft üzerindeki iş emirleri ile birlikte değerlendirin.",
      "Böylece planlanan rota ile gerçekleşen rota, araç konumu, operasyon süresi ve toplama noktaları aynı operasyon içerisinde izlenebilir hale gelir. Canlı araç verilerinin toplama operasyonlarıyla eşleştirilmesi, saha ile operasyon merkezi arasındaki koordinasyonu kolaylaştırır ve filo görünürlüğünü artırır.",
    ],
  },
  {
    title: "Uygulama Örnekleri",
    paragraphs: [
      "Sanayi, OSB ve Belediye Toplama Operasyonları: Farklı operasyon modellerinde kullanılan araçların sefer, rota ve atık toplama performanslarını tek platform üzerinden takip edin. Sanayi ve OSB operasyonlarında farklı fabrikalar ve tesislerden gerçekleştirilen toplama seferlerini araç, sürücü, kilometre, maliyet ve toplanan atık miktarı bazında değerlendirin. Belediye ve evsel atık operasyonlarında ise mahalle veya bölge bazlı toplama rotalarını, günlük sefer sayılarını, araç kullanımını ve toplanan atık miktarlarını takip edin.",
      "Araç üstü tartım sistemleri ile birlikte kullanıldığında; hangi araç, hangi bölge veya tesis, kaç sefer, kaç kilometre ve kaç kilogram/ton atık ilişkisinin ölçülebilir hale gelmesini sağlayın. Bu veriler araç sayısı, toplama sıklığı ve rota planlamalarının gerçek saha sonuçlarına göre geliştirilmesinde kullanılabilir.",
      "Zincir Mağaza Toplama Operasyonları: Farklı lokasyonlardaki mağazalara gerçekleştirilen seferleri, araçları ve sürücüleri merkezi olarak yönetin. Hangi aracın hangi mağazalara gittiğini, kaç kilometre yaptığını ve ne kadar atık topladığını takip ederek toplama sıklıklarını ve rota performansını analiz edin.",
    ],
  },
];

const depositSections = [
  {
    title: "DBYS Entegrasyonu ile Sahada Tek Uygulama Kullanın",
    paragraphs: [
      "AtıkSoft’un DBYS ile entegre çalışması sayesinde depozito toplama operasyonlarında sahadaki personelin aynı işlem için birden fazla uygulama kullanmasına gerek kalmaz. Toplama işlemi, görev takibi, adet kaydı, lokasyon bilgisi ve operasyon kapanışı AtıkSoft mobil uygulaması üzerinden gerçekleştirilir.",
      "Sahada oluşturulan ilgili veriler entegrasyon aracılığıyla DBYS’ye aktarılır. Böylece toplama personelinin aynı operasyonu önce AtıkSoft’ta, ardından ayrıca DOA uygulamasında tekrar işlemesi gerekmez.",
      "Sahada tek uygulama ile çalışma sağlanır; operasyon süreleri kısalır, kullanıcı hatalarının önüne geçilmesine yardımcı olunur ve uygulamalar arasında geçiş ihtiyacı ortadan kalkar. AtıkSoft’ta oluşan operasyon verileri DBYS ile dijital olarak paylaşılabilir.",
      "Sonuç olarak AtıkSoft, depozito toplama operasyonunu sahada yöneten ana uygulama haline gelirken gerekli veriler arka planda ilgili sisteme aktarılır. Saha personeli için tek uygulama, merkez için bütünleşik veri akışı sağlanır.",
    ],
  },
  {
    title: "Depozitoyu Mevcut Operasyonunuza Entegre Edin",
    paragraphs: [
      "AtıkSoft ile depozito yönetimini ayrı bir saha operasyonu olmaktan çıkarın. HORECA, DİM ve MİN süreçlerini; araç, rota, iş emri, saha personeli, operasyon durumu ve DBYS entegrasyonu ile aynı platform üzerinden yönetin.",
      "Depozitolu ambalajlar ile diğer atık toplama süreçlerinin ortak altyapıda yönetilmesi sayesinde daha sade, ölçülebilir ve bütünsel bir atık toplama modeli oluşturun.",
    ],
  },
  {
    title: "HORECA, DİM ve MİN Operasyonlarını Tek Sistemden Takip Edin",
    paragraphs: [
      "Farklı depozito toplama modellerini aynı operasyon altyapısı içerisinde yönetin.",
    ],
    list: [
      "HORECA noktalarından gerçekleştirilen manuel toplama operasyonları",
      "DİM noktalarındaki depozitolu ambalaj toplama ve lojistik süreçleri",
      "MİN üzerinden gerçekleştirilen toplama operasyonları",
      "Operatör, taşeron ve saha ekipleri arasındaki görev dağılımları",
      "Adet, lokasyon, tarih ve teslim kayıtları",
    ],
    after: [
      "Farklı depozito kanallarında oluşan saha verileri ortak bir operasyon ve raporlama altyapısında birleştirilir.",
    ],
  },
  {
    title: "Depozito ve Diğer Atık Toplamalarını Birlikte Planlayın",
    paragraphs: [
      "Depozitolu ambalaj toplama operasyonlarının diğer geri dönüştürülebilir atık toplama faaliyetlerinden tamamen ayrı yürütülmesi gerekmez.",
      "AtıkSoft üzerinde aynı lokasyonda bulunan depozitolu ambalajlar, kağıt-karton, plastik, cam ve diğer geri dönüştürülebilir atıklar aynı saha planlaması içerisinde değerlendirilebilir.",
      "Araçların ve saha ekiplerinin farklı atık türleri için ayrı ayrı planlanması yerine mevcut toplama kapasitesi daha bütünsel şekilde kullanılabilir. Böylece aynı lokasyona yapılan gereksiz veya mükerrer seferlerin azaltılmasına, araç kullanımının iyileştirilmesine ve saha operasyonlarının sadeleştirilmesine yönelik bir altyapı oluşturulur.",
    ],
  },
  {
    title: "Rota ve Dijital İş Emirlerini Yönetin",
    paragraphs: [
      "Depozito toplama operasyonları için araç, sürücü ve saha personeli atamalarını AtıkSoft üzerinden gerçekleştirin. Yetkili kullanıcılar masaüstü panelinden toplama noktalarını planlayabilir, saha ekiplerine dijital iş emirleri oluşturabilir ve gün içerisinde değişen operasyon ihtiyaçlarına göre görevleri güncelleyebilir.",
      "Saha personeli kendisine atanan görevleri mobil uygulama üzerinden görüntüler ve işlem sonucunda oluşan adet, teslim, lokasyon ve operasyon bilgilerini sisteme aktarır.",
      "Böylece depozito operasyonlarında planlama, rotalama, görev atama, saha doğrulama ve operasyon kapanışı tek dijital altyapı üzerinden yönetilir.",
    ],
  },
  {
    title: "DBYS ile Entegre Çalışın",
    paragraphs: [
      "AtıkSoft, Depozito Bilgi Yönetim Sistemi ile veri alışverişi sağlayabilecek entegrasyon altyapısı üzerinden depozito operasyonlarında oluşan verilerin merkezi sisteme aktarılmasını destekler.",
      "Sahada gerçekleşen toplama ve operasyon kayıtları dijital olarak oluşturulduktan sonra ilgili veriler entegrasyon kapsamında DBYS ile paylaşılabilir. Bu sayede saha ekiplerinin gerçekleştirdiği fiziksel operasyon ile merkezi depozito bilgi sistemi arasında manuel veri aktarımını azaltan bütünleşik bir yapı oluşturulabilir.",
      "AtıkSoft, saha operasyonunu yöneten sistem ile DBYS arasında dijital bir köprü görevi görerek operasyonel verinin kaynağında oluşturulmasını ve ilgili sisteme aktarılmasını kolaylaştırır.",
    ],
  },
  {
    title: "Depozito Hareketlerini Uçtan Uca İzleyin",
    paragraphs: [
      "Depozitolu ambalajların hangi lokasyondan toplandığını, hangi saha ekibi tarafından işlendiğini, hangi araç ile taşındığını ve hangi teslim noktasına ulaştığını kayıt altına alın.",
    ],
    list: [
      "Toplama noktası",
      "Depozitolu ambalaj adedi",
      "Ambalaj türü",
      "Tarih ve saat",
      "Araç ve sürücü",
      "Saha personeli",
      "İş emri",
      "Toplama ve teslim bilgileri",
      "Operasyon durumu",
      "DBYS ile paylaşılacak operasyon kayıtları",
    ],
    after: ["Tüm veriler tek bir dijital kayıt altında ilişkilendirilebilir."],
  },
  {
    title: "Uygulama Örnekleri",
    paragraphs: [
      "HORECA Noktalarında Depozito Toplama: Otel, restoran, kafe ve benzeri HORECA noktalarında oluşan depozitolu ambalajların toplama taleplerini merkezi olarak yönetin. Toplama noktalarını rota içerisine dahil edin, saha personeline iş emri oluşturun ve gerçekleşen adet bilgilerini mobil uygulama üzerinden kayıt altına alın. Aynı noktadan alınacak diğer geri dönüştürülebilir atıklar da aynı operasyon içerisinde planlanabilir.",
      "DİM ve MİN Toplama Operasyonlarının Yönetimi: DİM ve MİN noktalarından gerçekleştirilen toplama operasyonlarını araç, rota, saha ekibi ve operasyon durumu bazında takip edin. Hangi noktadan ne zaman toplama yapıldığı, hangi DİM haznesinin boşaltıldığı, kaç poşet depozitolu ambalaj alındığı ve ilgili yükün hangi operasyonla taşındığı kayıt altına alınır.",
      "Farklı toplama kanallarından gelen veriler ortak AtıkSoft altyapısında birleştirilerek merkezi operasyon görünürlüğü sağlanır.",
    ],
  },
];

function DepositPage() {
  const [catalogPage, setCatalogPage] = useState(1);
  const catalogPageCount = 8;

  return (
    <div className="guide-page solution-page deposit-page">
      <SiteHeader />
      <main>
        <section className="guide-hero">
          <div className="container">
            <p className="eyebrow">
              <span /> ÇÖZÜMLERİMİZ
            </p>
            <h1>
              Depozito
              <br />
              <em>Yönetimi</em>
            </h1>
            <p>
              Depozito operasyonlarını sahadan merkeze tek platformda yönetin.
            </p>
          </div>
        </section>
        <section className="deposit-feature container">
          <div>
            <p className="section-kicker">ATIKSOFT DEPOZİTO</p>
            <h2>
              Sahada tek uygulama,
              <br />
              <span>merkezde bütünleşik veri.</span>
            </h2>
            <p>
              Depozito toplama operasyonlarınızı DBYS entegrasyonu, mobil saha
              uygulaması ve dijital iş emirleriyle sadeleştirin.
            </p>
          </div>
          <div className="deposit-feature-image">
            <img
              src="/depozito-yonetimi.png"
              alt="AtıkSoft Depozito Yönetimi"
            />
          </div>
        </section>
        <section
          className="deposit-catalog container"
          aria-label="Depozito kataloğu"
        >
          <div className="deposit-catalog-heading">
            <div>
              <p className="section-kicker">DEPOZİTO KATALOĞU</p>
              <h2>
                Kataloğu <span>inceleyin.</span>
              </h2>
            </div>
            <p>
              Sağ ve sol okları kullanarak katalog sayfaları arasında geçiş
              yapın.
            </p>
          </div>
          <div className="catalog-reader">
            <button
              className="catalog-control"
              type="button"
              onClick={() => setCatalogPage((page) => Math.max(1, page - 1))}
              disabled={catalogPage === 1}
              aria-label="Önceki katalog sayfası"
            >
              <ChevronLeft size={24} />
            </button>
            <div className="catalog-page" key={catalogPage}>
              <img
                src={`/depozito-katalogu/page-${catalogPage}.png`}
                alt={`Depozito kataloğu ${catalogPage}. sayfa`}
              />
            </div>
            <button
              className="catalog-control"
              type="button"
              onClick={() =>
                setCatalogPage((page) => Math.min(catalogPageCount, page + 1))
              }
              disabled={catalogPage === catalogPageCount}
              aria-label="Sonraki katalog sayfası"
            >
              <ChevronRight size={24} />
            </button>
          </div>
          <p className="catalog-page-number">
            {catalogPage} / {catalogPageCount}
          </p>
        </section>
        <section className="guide-content container">
          <div className="guide-intro">
            <p className="section-kicker">DEPOZİTO OPERASYONLARI</p>
            <h2>
              Operasyonun her adımını{" "}
              <span>tek sistemden yönetin.</span>
            </h2>
          </div>
          <div className="guide-sections">
            {depositSections.map((section, index) => (
              <article className="guide-section" key={section.title}>
                <span>{String(index + 1).padStart(2, "0")}</span>
                <div>
                  <h3>{section.title}</h3>
                  {section.paragraphs.map((paragraph) => (
                    <p key={paragraph}>{paragraph}</p>
                  ))}
                  {section.list && (
                    <ul className="reporting-list">
                      {section.list.map((item) => (
                        <li key={item}>{item}</li>
                      ))}
                    </ul>
                  )}
                  {section.after?.map((paragraph) => (
                    <p key={paragraph}>{paragraph}</p>
                  ))}
                </div>
              </article>
            ))}
          </div>
        </section>
      </main>
    </div>
  );
}

function LogisticsPage() {
  const [catalogPage, setCatalogPage] = useState(1);
  const catalogPageCount = 12;

  return (
    <div className="guide-page solution-page">
      <SiteHeader />
      <main>
        <section className="guide-hero">
          <div className="container">
            <p className="eyebrow">
              <span /> ÇÖZÜMLERİMİZ
            </p>
            <h1>
              Araç, Rota ve
              <br />
              <em>Lojistik Yönetimi</em>
            </h1>
            <p>
              Filo ve saha operasyonlarınızı tek platform üzerinden yönetin.
            </p>
          </div>
        </section>
        <section
          className="deposit-catalog logistics-catalog container"
          aria-label="Araç arıza bakım kataloğu"
          onKeyDown={(event) => {
            if (event.key === "ArrowLeft" || event.key === "ArrowRight") {
              event.preventDefault();
              const direction = event.key === "ArrowRight" ? 1 : -1;
              setCatalogPage((page) =>
                Math.max(1, Math.min(catalogPageCount, page + direction)),
              );
            }
          }}
        >
          <div className="deposit-catalog-heading">
            <div>
              <p className="section-kicker">ARAÇ ARIZA BAKIM MÜDÜRLÜĞÜ</p>
              <h2>
                Bakım yönetimini <span>yakından inceleyin.</span>
              </h2>
            </div>
            <p>
              Araç arıza ve bakım süreçlerine ilişkin sunumumuzu sağ ve sol
              oklarla sayfa sayfa keşfedin.
            </p>
          </div>
          <div className="catalog-reader">
            <button
              className="catalog-control"
              type="button"
              onClick={() => setCatalogPage((page) => Math.max(1, page - 1))}
              disabled={catalogPage === 1}
              aria-label="Önceki sunum sayfası"
              aria-controls="logistics-catalog-page"
            >
              <ChevronLeft size={24} />
            </button>
            <div
              className="catalog-page"
              id="logistics-catalog-page"
              tabIndex={0}
            >
              <img
                key={catalogPage}
                src={`/arac-bakim-katalogu/page-${String(catalogPage).padStart(2, "0")}.jpg`}
                alt={`ATIKSOFT Araç Arıza Bakım Müdürlüğü sunumu, ${catalogPage}. sayfa`}
                width={1800}
                height={1273}
              />
            </div>
            <button
              className="catalog-control"
              type="button"
              onClick={() =>
                setCatalogPage((page) => Math.min(catalogPageCount, page + 1))
              }
              disabled={catalogPage === catalogPageCount}
              aria-label="Sonraki sunum sayfası"
              aria-controls="logistics-catalog-page"
            >
              <ChevronRight size={24} />
            </button>
          </div>
          <div className="logistics-catalog-footer">
            <p
              className="catalog-page-number"
              aria-live="polite"
              aria-atomic="true"
            >
              Sayfa {catalogPage} / {catalogPageCount}
            </p>
            <a
              href="/documents/arac-ariza-bakim.pdf"
              target="_blank"
              rel="noreferrer"
            >
              <FileText size={16} /> PDF’yi aç <ExternalLink size={14} />
            </a>
          </div>
        </section>
        <section className="guide-content container">
          <div className="guide-intro logistics-intro">
            <p className="section-kicker">FİLO VE LOJİSTİK</p>
            <h2>
              Rotayı görünür kılın,
              <br />
              <span>operasyonu güçlendirin.</span>
            </h2>
          </div>
          <div className="guide-sections">
            {logisticsSections.map((section, index) => (
              <article className="guide-section" key={section.title}>
                <span>{String(index + 1).padStart(2, "0")}</span>
                <div>
                  <h3>{section.title}</h3>
                  {section.paragraphs.map((paragraph) => (
                    <p key={paragraph}>{paragraph}</p>
                  ))}
                  {section.list && (
                    <ul className="reporting-list">
                      {section.list.map((item) => (
                        <li key={item}>{item}</li>
                      ))}
                    </ul>
                  )}
                  {section.after?.map((paragraph) => (
                    <p key={paragraph}>{paragraph}</p>
                  ))}
                </div>
              </article>
            ))}
          </div>
        </section>
      </main>
    </div>
  );
}

function CollectionPage() {
  return (
    <div className="guide-page solution-page">
      <SiteHeader />
      <main>
        <section className="guide-hero">
          <div className="container">
            <p className="eyebrow">
              <span /> ÇÖZÜMLERİMİZ
            </p>
            <h1>
              Atık Toplama ve
              <br />
              <em>Saha Operasyonları</em>
            </h1>
            <p>Sahadaki her atık hareketini dijital olarak yönetin.</p>
          </div>
        </section>
        <section className="guide-content container solution-content-with-image">
          <div className="guide-intro">
            <p className="section-kicker">SAHA OPERASYONLARI</p>
            <h2>
              Atık yönetimini sahadan
              <br />
              <span>merkeze taşıyın.</span>
            </h2>
          </div>
          <div className="solution-feature-image">
            <img
              src="/atiktoplama_sahaop.jpeg"
              alt="Atık toplama ve saha operasyonları"
            />
          </div>
          <div className="guide-sections">
            {collectionSections.map((section, index) => (
              <article className="guide-section" key={section.title}>
                <span>{String(index + 1).padStart(2, "0")}</span>
                <div>
                  <h3>{section.title}</h3>
                  {section.paragraphs.map((paragraph) => (
                    <p key={paragraph}>{paragraph}</p>
                  ))}
                  {section.list && (
                    <ul className="reporting-list">
                      {section.list.map((item) => (
                        <li key={item}>{item}</li>
                      ))}
                    </ul>
                  )}
                  {section.after?.map((paragraph) => (
                    <p key={paragraph}>{paragraph}</p>
                  ))}
                </div>
              </article>
            ))}
          </div>
        </section>
      </main>
    </div>
  );
}

function InventoryPage() {
  return (
    <div className="guide-page solution-page">
      <SiteHeader />
      <main>
        <section className="guide-hero">
          <div className="container">
            <p className="eyebrow">
              <span /> ÇÖZÜMLERİMİZ
            </p>
            <h1>
              Ekipman ve
              <br />
              <em>Envanter Yönetimi</em>
            </h1>
            <p>Envanter, stok ve sevk süreçlerini bütünsel olarak yönetin.</p>
          </div>
        </section>
        <section className="guide-content container">
          <div className="guide-intro">
            <p className="section-kicker">FİZİKSEL VARLIKLAR</p>
            <h2>
              Sahadaki ekipmanınızı
              <br />
              <span>dijitalde görünür kılın.</span>
            </h2>
          </div>
          <div className="guide-sections">
            {inventorySections.map((section, index) => (
              <article className="guide-section" key={section.title}>
                <span>{String(index + 1).padStart(2, "0")}</span>
                <div>
                  <h3>{section.title}</h3>
                  {section.paragraphs.map((paragraph) => (
                    <p key={paragraph}>{paragraph}</p>
                  ))}
                  {section.list && (
                    <ul className="reporting-list">
                      {section.list.map((item) => (
                        <li key={item}>{item}</li>
                      ))}
                    </ul>
                  )}
                </div>
              </article>
            ))}
          </div>
        </section>
      </main>
    </div>
  );
}

function IntegrationPage() {
  return (
    <div className="guide-page solution-page">
      <SiteHeader />
      <main>
        <section className="guide-hero">
          <div className="container">
            <p className="eyebrow">
              <span /> ÇÖZÜMLERİMİZ
            </p>
            <h1>
              Entegrasyonlar ve
              <br />
              <em>Dijital Evrak</em>
            </h1>
            <p>Mevcut sistemlerinizi AtıkSoft ile birbirine bağlayın.</p>
          </div>
        </section>
        <section className="guide-content container">
          <div className="guide-intro">
            <p className="section-kicker">BÜTÜNLEŞİK OPERASYON</p>
            <h2>
              Sistemleriniz konuşsun,
              <br />
              <span>veriniz akışta kalsın.</span>
            </h2>
          </div>
          <div className="guide-sections">
            {integrationSections.map((section, index) => (
              <article className="guide-section" key={section.title}>
                <span>{String(index + 1).padStart(2, "0")}</span>
                <div>
                  <h3>{section.title}</h3>
                  {section.paragraphs.map((paragraph) => (
                    <p key={paragraph}>{paragraph}</p>
                  ))}
                  {section.list && (
                    <ul className="reporting-list">
                      {section.list.map((item) => (
                        <li key={item}>{item}</li>
                      ))}
                    </ul>
                  )}
                  {section.after?.map((paragraph) => (
                    <p key={paragraph}>{paragraph}</p>
                  ))}
                </div>
              </article>
            ))}
          </div>
        </section>
      </main>
    </div>
  );
}

function HouseholdWastePage() {
  return (
    <div className="guide-page solution-page">
      <SiteHeader />
      <main>
        <section className="guide-hero">
          <div className="container">
            <p className="eyebrow">
              <span /> ÇÖZÜMLERİMİZ
            </p>
            <h1>
              Evsel Atık
              <br />
              <em>(Çöp) Yönetimi</em>
            </h1>
            <p>Evsel atık toplama operasyonlarını dijital olarak yönetin.</p>
          </div>
        </section>
        <section className="guide-content container">
          <div className="guide-intro">
            <p className="section-kicker">SAHA OPERASYONLARI</p>
            <h2>
              Toplamayı değil,
              <br />
              <span>tüm operasyonu yönetin.</span>
            </h2>
          </div>
          <div className="guide-sections">
            {householdSections.map((section, index) => (
              <article className="guide-section" key={section.title}>
                <span>{String(index + 1).padStart(2, "0")}</span>
                <div>
                  <h3>{section.title}</h3>
                  {section.paragraphs.map((paragraph) => (
                    <p key={paragraph}>{paragraph}</p>
                  ))}
                  {section.list && (
                    <ul className="reporting-list">
                      {section.list.map((item) => (
                        <li key={item}>{item}</li>
                      ))}
                    </ul>
                  )}
                  {section.after?.map((paragraph) => (
                    <p key={paragraph}>{paragraph}</p>
                  ))}
                </div>
              </article>
            ))}
          </div>
        </section>
      </main>
    </div>
  );
}

function ReportingPage() {
  return (
    <div className="guide-page solution-page">
      <SiteHeader />
      <main>
        <section className="guide-hero">
          <div className="container">
            <p className="eyebrow">
              <span /> ÇÖZÜMLERİMİZ
            </p>
            <h1>
              Raporlama ve
              <br />
              <em>Sürdürülebilirlik</em>
            </h1>
            <p>Saha verisini ölçülebilir performansa dönüştürün.</p>
          </div>
        </section>
        <section className="guide-content container solution-content-with-image">
          <div className="guide-intro">
            <p className="section-kicker">VERİDEN DEĞERE</p>
            <h2>
              Atık yönetimini
              <br />
              <span>verilerle yönetin.</span>
            </h2>
          </div>
          <div className="solution-feature-image">
            <img
              src="/raporlama_surdurebilirlik.jpeg"
              alt="Raporlama ve sürdürülebilirlik"
            />
          </div>
          <div className="guide-sections">
            {reportingSections.map((section, index) => (
              <article className="guide-section" key={section.title}>
                <span>{String(index + 1).padStart(2, "0")}</span>
                <div>
                  <h3>{section.title}</h3>
                  {section.paragraphs.map((paragraph) => (
                    <p key={paragraph}>{paragraph}</p>
                  ))}
                  {section.list && (
                    <ul className="reporting-list">
                      {section.list.map((item) => (
                        <li key={item}>{item}</li>
                      ))}
                    </ul>
                  )}
                  {section.after?.map((paragraph) => (
                    <p key={paragraph}>{paragraph}</p>
                  ))}
                </div>
              </article>
            ))}
          </div>
        </section>
      </main>
    </div>
  );
}

function ResearchPage() {
  return (
    <div className="research-page">
      <SiteHeader />
      <main>
        <section className="research-hero">
          <div className="container research-hero-inner">
            <div>
              <p className="eyebrow">
                <span /> KURUMSAL / TEKNOLOJİ
              </p>
              <h1>
                Ar-Ge ve
                <br />
                <em>Teknoloji</em>
              </h1>
              <p>ATIKSOFT'un merkezinde sürekli Ar-Ge var.</p>
            </div>
            <div className="research-hero-image">
              <img
                src="/arge_teknoloji.jpeg"
                alt="ATIKSOFT Ar-Ge ve teknoloji çalışmaları"
              />
            </div>
          </div>
        </section>
        <section className="research-content container">
          <div className="research-heading">
            <p className="section-kicker">SÜREKLİ GELİŞİM</p>
            <h2>
              Sahadaki problemlere
              <br />
              <span>teknolojiyle çözümler.</span>
            </h2>
          </div>
          <div className="research-copy">
            <p className="lead">
              ATIKSOFT, yalnızca mevcut süreçleri dijital ortama aktaran bir
              yazılım olarak değil; atık yönetimindeki operasyonel problemlere
              teknolojiyle yeni çözümler geliştiren sürekli bir Ar-Ge platformu
              olarak tasarlandı.
            </p>
            <p>
              Bu doğrultuda ATIKSOFT'un teknolojik altyapısının geliştirilmesine
              yönelik çalışmalarımız TÜBİTAK 1507 KOBİ Ar-Ge Başlangıç Destek
              Programı kapsamında desteklendi ve Ar-Ge projemiz başarıyla
              tamamlandı.
            </p>
            <p>
              Ürün geliştirme sürecimiz boyunca masaüstü ve mobil uygulamalar,
              saha veri toplama teknolojileri, ekipman ve araç takibi, dijital
              operasyon yönetimi, raporlama ve farklı sistemlerle entegrasyon
              gibi birçok alanda çalışmalar gerçekleştirdik.
            </p>
            <p>
              Ar-Ge yaklaşımımız yalnızca ulusal ölçekte değil, temiz teknoloji
              ekosisteminde de karşılık buldu. ATIKSOFT, UNIDO ve TÜBİTAK iş
              birliğiyle yürütülen Global Cleantech Innovation Programme (GCIP)
              Türkiye 2024 kapsamında ulusal finalist girişimler arasında yer
              aldı.
            </p>
          </div>
        </section>
        <section className="research-focus">
          <div className="container research-focus-inner">
            <div>
              <p className="section-kicker light">BUGÜN ÇALIŞMALARIMIZI</p>
              <h2>
                Teknolojiyi sahadan kopuk değil,
                <br />
                <em>sahanın ihtiyaçlarıyla geliştiriyoruz.</em>
              </h2>
            </div>
            <ul>
              {researchFocusAreas.map((area) => (
                <li key={area}>{area}</li>
              ))}
            </ul>
          </div>
        </section>
        <section className="research-closing container">
          <p>
            Teknolojiyi sahadan kopuk değil, sahanın gerçek ihtiyaçlarından
            hareketle geliştiriyoruz. Her yeni proje, entegrasyon ve saha
            uygulaması ATIKSOFT'un gelişen teknoloji altyapısına yeni bir
            deneyim kazandırıyor. Amacımız, atık yönetiminde daha ölçülebilir,
            izlenebilir ve verimli bir dijital ekosistem oluşturmak.
          </p>
        </section>
      </main>
    </div>
  );
}

function WasteGuidePage() {
  return (
    <div className="guide-page">
      <SiteHeader />
      <main>
        <section className="guide-hero">
          <div className="container">
            <p className="eyebrow">
              <span /> KAYNAKLAR
            </p>
            <h1>
              Atık Yönetimi
              <br />
              <em>Rehberi</em>
            </h1>
            <p>
              Atık yönetiminde sahada karşılığı olan gözlemler, çıkarımlar ve
              iyi uygulama yaklaşımları.
            </p>
          </div>
        </section>
        <section className="guide-content container">
          <div className="guide-intro">
            <p className="section-kicker">ATIK YÖNETİMİNE BAKIŞ</p>
            <h2>
              Sahadan gelen deneyimle,
              <br />
              <span>daha bütünsel bir yaklaşım.</span>
            </h2>
          </div>
          <div className="guide-sections">
            {wasteGuideSections.map((section, index) => (
              <article className="guide-section" key={section.title}>
                <span>{String(index + 1).padStart(2, "0")}</span>
                <div>
                  <h3>{section.title}</h3>
                  {section.paragraphs.map((paragraph) => (
                    <p key={paragraph}>{paragraph}</p>
                  ))}
                </div>
              </article>
            ))}
          </div>
        </section>
      </main>
    </div>
  );
}

function PlaceholderPage({ category, title }) {
  return (
    <div className="placeholder-page">
      <SiteHeader />
      <main className="placeholder-main container">
        <p className="eyebrow">
          <span /> {category.toUpperCase()}
        </p>
        <h1>{title}</h1>
        <div className="placeholder-card">
          <div className="placeholder-dot">A</div>
          <div>
            <p className="placeholder-label">İÇERİK HAZIRLANIYOR</p>
            <h2>Bu sayfa yakında yayında olacak.</h2>
            <p>
              Atiksoft web sitesinin yeni içerik yapısı hazırlanıyor. Bu alan,
              ilgili sayfanın gerçek içeriği hazırlandığında güncellenecektir.
            </p>
            <a className="primary-button" href="/">
              Ana sayfaya dön <ArrowRight size={17} />
            </a>
          </div>
        </div>
      </main>
    </div>
  );
}

function App() {
  const currentPath = decodeURIComponent(window.location.pathname).replace(/\/+$/, "") || "/";
  const currentPage = placeholderPages[currentPath];
  const [contactForm, setContactForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    company: "",
    subject: "Genel Bilgi",
    message: "",
  });
  const [contactStatus, setContactStatus] = useState(null);
  const [isContactSubmitting, setIsContactSubmitting] = useState(false);

  useEffect(() => {
    if (currentPage || !("IntersectionObserver" in window)) return undefined;

    const elements = document.querySelectorAll("[data-reveal]");
    const observer = new IntersectionObserver(
      (entries) =>
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        }),
      { threshold: 0.12, rootMargin: "0px 0px -40px" },
    );

    elements.forEach((element) => observer.observe(element));
    return () => observer.disconnect();
  }, [currentPage]);

  const handleContactSubmit = async (event) => {
    event.preventDefault();
    setContactStatus(null);
    if (!isEmailConfigured()) {
      setContactStatus("config");
      return;
    }
    setIsContactSubmitting(true);
    const result = await sendContactMessage(contactForm);
    setIsContactSubmitting(false);
    if (result.success) {
      setContactStatus("success");
      setContactForm({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        company: "",
        subject: "Genel Bilgi",
        message: "",
      });
    } else {
      setContactStatus("error");
    }
  };

  if (currentPath === "/kurumsal/ar-ge-ve-teknoloji") {
    return <ResearchPage />;
  }
  if (currentPath === "/cozumler/raporlama") {
    return <ReportingPage />;
  }
  if (currentPath === "/cozumler/evsel-atik") {
    return <HouseholdWastePage />;
  }
  if (currentPath === "/cozumler/entegrasyonlar") {
    return <IntegrationPage />;
  }
  if (currentPath === "/cozumler/envanter-yonetimi") {
    return <InventoryPage />;
  }
  const solutionPath = currentPath
    .replace(/\/+$/, "")
    .toLowerCase();
  if (
    solutionPath === "/cozumler/atık-toplama" ||
    solutionPath === "/cozumler/atik-toplama"
  ) {
    return <CollectionPage />;
  }
  if (currentPath === "/cozumler/lojistik-yonetimi") {
    return <LogisticsPage />;
  }
  if (currentPath === "/cozumler/depozito-yonetimi") {
    return <DepositPage />;
  }
  if (currentPath === "/kaynaklar/rehber") {
    return <WasteGuidePage />;
  }
  if (currentPage) {
    return <PlaceholderPage category={currentPage[0]} title={currentPage[1]} />;
  }
  if (currentPath === "/kurumsal/hakkimizda") {
    return <AboutPage />;
  }
  if (currentPath === "/kurumsal/is-ortaklarimiz") {
    return <PartnersPage />;
  }
  if (currentPath === "/kurumsal/belgelerimiz") {
    return <DocumentsPage />;
  }
  if (currentPath === "/kurumsal/referanslar") {
    return <ReferencesPage />;
  }
  if (currentPath === "/kurumsal/politikalarimiz") {
    return <PoliciesPage />;
  }
  if (currentPath === "/blog") {
    return <BlogPage />;
  }
  if (currentPath === "/kaynaklar/sss") {
    return <FAQPage />;
  }

  return (
    <div className="site-shell">
      <SiteHeader />

      <main>
        <section className="hero container">
          <div className="hero-copy">
            <p className="eyebrow">
              <span /> ATIK YÖNETİMİNDE DİJİTAL DÖNÜŞÜM
            </p>
            <h1>
              Şehirleri daha <em>akıllı</em>, geleceği daha temiz kılıyoruz.
            </h1>
            <p className="hero-text">
              Atık yönetim süreçlerinizi tek bir platformda yönetin. Veriye
              dayalı, sürdürülebilir ve ölçülebilir çözümlerle operasyonlarınızı
              geleceğe taşıyın.
            </p>
            <div className="hero-actions">
              <a className="primary-button" href="#cozumler">
                Çözümlerimizi keşfedin <ArrowRight size={18} />
              </a>
              <a className="text-button" href="#hakkimizda">
                Bizi tanıyın <ChevronRight size={17} />
              </a>
            </div>
          </div>
          <div className="hero-visual">
            <div className="visual-orbit orbit-one" />
            <div className="visual-orbit orbit-two" />
            <div className="hero-image-wrap">
              <img src="/anasayfa.jpeg" alt="AtıkSoft atık yönetimi" />
            </div>
            <div className="floating-stat">
              <span className="stat-icon">
                <Check size={16} />
              </span>
              <div>
                <strong>%35</strong>
                <small>bütçe tasarrufu</small>
              </div>
            </div>
            <div className="floating-label">
              Atık akışlarında{" "}
              <br />
              <strong>izlenebilirlik</strong>
            </div>
          </div>
        </section>

        <section className="trust-strip" data-reveal>
          <div className="container trust-inner">
            <span>GÜVENEN KURUMLAR</span>
            <div className="trust-logos">
              <div className="trust-logos-track">
                {[...referenceLogos, ...referenceLogos].map(
                  (reference, index) => (
                    <img
                      key={`${reference.name}-${index}`}
                      src={reference.image}
                      alt={index >= referenceLogos.length ? "" : reference.name}
                      aria-hidden={index >= referenceLogos.length}
                    />
                  ),
                )}
              </div>
            </div>
          </div>
        </section>

        <section
          className="intro-section container"
          id="hakkimizda"
          data-reveal
        >
          <div className="section-kicker">01 / HAKKIMIZDA</div>
          <div className="intro-grid">
            <h2>
              Atığı bir sorun değil,
              <br />
              <span>değer</span> olarak görüyoruz.
            </h2>
            <div>
              <p className="lead">
                Atiksoft, sürdürülebilir bir gelecek için teknoloji ve insanı
                bir araya getirir.
              </p>
              <p>
                Şehirlerin ve kurumların atık yönetim süreçlerini uçtan uca
                dijitalleştiriyor, daha verimli operasyonlar ve daha yaşanabilir
                çevreler için çalışıyoruz.
              </p>
              <a className="inline-link" href="/kurumsal/hakkimizda">
                Atiksoft’u tanıyın <ArrowRight size={16} />
              </a>
            </div>
          </div>
        </section>

        <section className="solutions-section" id="cozumler" data-reveal>
          <div className="container">
            <div className="section-heading">
              <div>
                <div className="section-kicker">02 / ÇÖZÜMLERİMİZ</div>
                <h2>
                  Operasyonunuzun her adımında
                  <br />
                  <span>yanınızdayız.</span>
                </h2>
              </div>
            </div>
            <div className="solution-grid">
              <div className="solution-track">
                {[...solutionCards, ...solutionCards].map((solution, index) => (
                  <a
                    className={`solution-card${index % solutionCards.length === 0 ? " featured" : ""}`}
                    href={solution.href}
                    key={`${solution.title}-${index}`}
                  >
                    <span>
                      {String((index % solutionCards.length) + 1).padStart(
                        2,
                        "0",
                      )}
                    </span>
                    <h3>{solution.title}</h3>
                    <p>{solution.text}</p>
                    <ArrowRight />
                  </a>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="latest-section container" data-reveal>
          <div className="section-heading">
            <div>
              <div className="section-kicker">03 / SON GELİŞMELER</div>
              <h2>Bizden haberler.</h2>
            </div>
            <a className="inline-link" href="/blog">
              Tüm yazıları gör <ArrowRight size={16} />
            </a>
          </div>
          <div className="news-grid">
            {news.map((item) => (
              <a
                className="news-card"
                data-reveal
                href="/blog"
                key={item.title}
              >
                <div className="news-image">
                  <img src={item.image} alt={item.title} />
                  <span>{item.tag}</span>
                </div>
                <div className="news-content">
                  <small>{item.date}</small>
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>
                  <span className="read-more">
                    Devamını oku <ArrowRight size={15} />
                  </span>
                </div>
              </a>
            ))}
          </div>
        </section>

        <section className="contact-section" id="iletisim" data-reveal>
          <div className="container">
            <div className="section-heading contact-heading">
              <div>
                <div className="section-kicker">04 / İLETİŞİM</div>
                <h2>
                  Teknoloji ortağınız olalım.
                  <br />
                  <span>
                    Saha operasyonlarından raporlamaya kadar ihtiyaçlarınıza
                    birlikte çözüm{" "}
                  </span>{" "}
                  üretelim.
                </h2>
              </div>
              <p>Operasyonlarınız için en doğru çözümü birlikte keşfedelim.</p>
            </div>
            <div className="contact-layout">
              <div className="map-wrap">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3124.5447891234567!2d27.180428!3d38.450079!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMzjCsDI3JzAwLjMiTiAyN8KwMTAnNTguMiJF!5e0!3m2!1str!2str!4v1234567890"
                  title="ATIKSOFT Lokasyon"
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
              <div className="contact-cards">
                <a href="mailto:bilgi@atiksoft.com" className="contact-card">
                  <span>
                    <Mail size={20} />
                  </span>
                  <small>E-POSTA</small>
                  <strong>bilgi@atiksoft.com</strong>
                </a>
                <a href="tel:+902324366335" className="contact-card">
                  <span>
                    <Phone size={20} />
                  </span>
                  <small>TELEFON</small>
                  <strong>+90 (232) 436 63 35</strong>
                </a>
                <div className="contact-card">
                  <span>
                    <MapPin size={20} />
                  </span>
                  <small>ADRES</small>
                  <strong>
                    Mansuroğlu Mahallesi, 294 Sokak No:14/3
                    <br />
                    Bayraklı, İzmir, Türkiye
                  </strong>
                </div>
              </div>
            </div>
            <form
              className="contact-form"
              id="iletisim-form"
              onSubmit={handleContactSubmit}
            >
              <div className="contact-form-heading">
                <div>
                  <p className="section-kicker">BİZE YAZIN</p>
                  <h3>Size nasıl yardımcı olabiliriz?</h3>
                </div>
                <p>Formu doldurun, ekibimiz sizinle iletişime geçsin.</p>
              </div>
              <div className="contact-form-grid">
                <label>
                  Ad
                  <input
                    required
                    value={contactForm.firstName}
                    onChange={(e) =>
                      setContactForm({
                        ...contactForm,
                        firstName: e.target.value,
                      })
                    }
                    placeholder="Adınız"
                  />
                </label>
                <label>
                  Soyad
                  <input
                    required
                    value={contactForm.lastName}
                    onChange={(e) =>
                      setContactForm({
                        ...contactForm,
                        lastName: e.target.value,
                      })
                    }
                    placeholder="Soyadınız"
                  />
                </label>
                <label>
                  E-posta adresi
                  <input
                    required
                    type="email"
                    value={contactForm.email}
                    onChange={(e) =>
                      setContactForm({ ...contactForm, email: e.target.value })
                    }
                    placeholder="ornek@sirket.com"
                  />
                </label>
                <label>
                  Telefon numarası
                  <input
                    required
                    type="tel"
                    value={contactForm.phone}
                    onChange={(e) =>
                      setContactForm({ ...contactForm, phone: e.target.value })
                    }
                    placeholder="+90 5xx xxx xx xx"
                  />
                </label>
                <label>
                  Kurum / Şirket
                  <input
                    value={contactForm.company}
                    onChange={(e) =>
                      setContactForm({
                        ...contactForm,
                        company: e.target.value,
                      })
                    }
                    placeholder="Kurumunuz"
                  />
                </label>
                <label>
                  Konu
                  <select
                    value={contactForm.subject}
                    onChange={(e) =>
                      setContactForm({
                        ...contactForm,
                        subject: e.target.value,
                      })
                    }
                  >
                    <option>Genel Bilgi</option>
                    <option>Demo Talebi</option>
                    <option>Çözüm Ortaklığı</option>
                    <option>Teknik Destek</option>
                  </select>
                </label>
                <label className="contact-form-message">
                  Mesaj
                  <textarea
                    required
                    value={contactForm.message}
                    onChange={(e) =>
                      setContactForm({
                        ...contactForm,
                        message: e.target.value,
                      })
                    }
                    placeholder="Mesajınızı yazın"
                  />
                </label>
              </div>
              {contactStatus && (
                <p className={`contact-form-status ${contactStatus}`}>
                  {contactStatus === "success"
                    ? "Mesajınız başarıyla gönderildi."
                    : contactStatus === "config"
                      ? "Form gönderimi henüz yapılandırılmadı. Lütfen e-posta servis ayarlarını tamamlayın."
                      : "Mesaj gönderilemedi. Lütfen tekrar deneyin."}
                </p>
              )}
              <button
                className="primary-button contact-submit"
                type="submit"
                disabled={isContactSubmitting}
              >
                {isContactSubmitting ? "Gönderiliyor..." : "Mesajı gönder"}{" "}
                <ArrowRight size={17} />
              </button>
            </form>
          </div>
        </section>
      </main>
      <footer className="footer">
        <div className="container footer-inner">
          <a className="brand" href="/">
            <img src="/logo.png" alt="Atiksoft" />
          </a>
          <p>Akıllı şehirler, temiz bir gelecek.</p>
          <span>© 2025 Atiksoft</span>
        </div>
      </footer>
    </div>
  );
}

export default App;
